const messages = {
  login: {
    form: {
      emailInput: 'Informe su e-mail',
      passwordInput: 'Informe su contraseña',
      submitButton: 'Entrar',
      forgotPasswordLabel: 'Olvidó su contraseña?',
    },
    tooltips: {
      emailValidation: {
        title: 'Error',
        description: 'Por favor, informe un e-mail válido.',
      },
      passwordValidation: {
        title: 'Error',
        description: 'Por favor, informe una contraseña.',
      },
      loginValidation: {
        title: 'Datos inválidos',
        description: 'Verifique sus datos login e intente nuevamente.',
      },
      loginNotAllowed: {
        title: 'Inicio de sesión no permitido',
        description: 'No tienes permiso de acceso.',
      },
      blockByIncorrectLogin: {
        title: 'Usuario bloqueado',
        description:
          'Su usuario ha sido bloqueado por esforzarse demasiado. Por favor contacte al equipo de soporte.',
      },
      genericError: {
        title: 'Error',
        description:
          'No pudimos procesar su solicitud. Por favor, intente nuevamente más tarde.',
      },
    },
  },
  forgotPassword: {
    form: {
      description:
        'Enviaremos un código a su e-mail para recuperación de contraseña.',
      emailInput: 'Informe el e-mail registrado',
      submitButton: 'Enviar código',
    },
    tooltips: {
      emailValidation: {
        title: 'Error',
        description: 'Por favor, informe un e-mail válido.',
      },
    },
  },
  validateCode: {
    form: {
      description: 'Enviamos el código de validación a su e-mail.',
      codeInput: 'Ingrese el código recibido',
      submitButton: 'Enviar código',
    },
    tooltips: {
      codeValidation: {
        title: 'Error',
        description: 'Por favor, informe el código enviado para su e-mail.',
      },
    },
  },
  changePassword: {
    form: {
      description: 'Cambio de contraseña.',
      newPasswordInput: 'Nueva contraseña',
      passwordConfirmationInput: 'Confirme su nueva contraseña',
      submitButton: 'Cambiar contraseña',
      strongPassMessage:
        'IndeCX está atualizando sua política de segurança de senhas e precisamos que você cadastre uma nova senha segura na plataforma',
    },
    tooltips: {
      emptyFieldValidation: {
        title: 'Error',
        description: 'Por favor, informe y confirme su contraseña.',
      },
      passwordValidation: {
        title: 'Error',
        description: 'Las contraseñas deben ser iguales.',
      },
      strongPasswordValidation: {
        title: 'Erro',
        description: 'Senhas devem seguir nova política de segurança',
      },
    },
    alerts: {
      success: {
        title: 'Contraseña cambiada!',
        description: 'Usted ya puede ingresar con su nueva contraseña.',
      },
      failure: {
        title: 'Oops!',
        description: 'Hubo una falla en el procesamiento. Intente nuevamente.',
      },
    },
  },
  unsubscribe: {
    thankYou: 'Gracias',
    unsubscribeMsg:
      'Su e-mail fue desinscrito exitosamente de nuestra plataforma!',
    successTitle: '¡Su correo electrónico ha sido eliminado con éxito!',
    confirm:
      'Al hacer clic en el botón, se cancelará la suscripción y ya no recibirá este tipo de correo electrónico.',
    successSubTitle: 'Indique el motivo de su cancelación.',
    successSentFeedback: '¡Gracias por compartir tu razón!',
    successResubscribe: '¡Listo! ya se ha suscrito a esta lista de nuevo.',
    reasons: {
      dontReceiveEmails: 'Ya no deseo recibir estos correos electrónicos.',
      notInterested: 'El contenido no me interesa',
      dontAllowReceiving:
        'No me gusta recibir este tipo de email sin que me consulten',
      accidentallyCanceled:
        '¡Me di de baja por accidente! Quiero volver a suscribirme a esta lista, por favor',
      other: 'Otros',
    },
  },
  researchPage: {
    title: 'Encuesta de Satisfacción',
    firstMsg: 'Su opinión es muy importante para nosotros!',
    secondMsg: 'Gracias por su participación',
    defaultFeedbackMessage: '¿Quieres dejar un comentario?',
    send: 'Enviar',
    name: 'Nombre',
    email: 'Email',
    phone: 'Teléfono',
    errorMsg: {
      title: 'Oops... Algo salió mal!',
      description: 'Por favor, intente nuevamente más tarde.',
    },
    noQuestion: {
      title: 'Oops... La pregunta principal no fue respondida.',
      description: 'Por favor, insertar una nota.',
    },
    unavailable: {
      title:
        '¡Lo sentimos, lamentablemente este enlace ya no está disponible para realizar búsquedas!',
      description:
        'Pero no se preocupe, nuestro equipo de expertos le enviará una nueva encuesta pronto para mejorar su experiencia con nuestro producto y ¡estaremos encantados de saber de usted!',
    },
  },
  ssoError: {
    title: 'Sus credenciales son incorrectas!',
    description:
      'Es posible que su cuenta no exista o esté bloqueada. Contacta al administrador responsable de tu cuenta IndeCX.',
  },
  previewPage: {
    title: 'Encuesta de Satisfacción',
    firstMsg: 'Su opinión es muy importante para nosotros!',
    secondMsg: 'Gracias por su participación',
    back: 'Volver',
    send: 'Enviar',
  },
  notFound: {
    title: 'Página no encontrada',
    message:
      'La pagina que usted está intentando accesar no está disponible o tal vez nunca existió.',
    knowMore: 'Sepa más ',
    clickHere: 'haciendo click aqui.',
    back: 'Volver',
  },
  ssoPage: {
    auth: 'Autenticando',
    noAuth: 'No fue posible autenticar',
  },
  authentication: {
    accessCode: 'Código de Acceso',
    validate: 'Validar',
    noAccess: 'No tengo acceso a este teléfono',
  },
  menu: {
    allActionsLabel: 'todas las Acciones',
    titleMasterSettings: 'Configuraciones Maestras',
    titleSettings: 'Configuraciones',
    titleMyProfile: 'Mi Perfil',
    titleExportPdf: 'Exportar para PDF',
    settings: {
      accountData: {
        name: 'Datos de la cuenta',
        company: 'Empresa',
        cnpj: 'NIT o CUIT',
        plan: 'Plan',
        email: 'E-mail',
        apiKey: 'API Key',
        privacyPolicy: 'Política de Privacidad',
        clickHere: 'Haga click aqui para accesar.',
        none: 'Ninguna',
        mainMetric: 'Métrica principal',
        mainTime: 'Periodo principal',
        addEmail: 'Agregar e-mail',
        addPolicyLink: 'Link para Política de Privacidad',
        registerEmail: ' Registrar e-mail',
        chooseLogo: 'Elegir logo',
        companyEmail: 'E-mail de la empresa',
        choosePrivacyPolicy: 'Elegir Política de Privacidad',
        cancel: 'Cancelar',
        saveLogo: 'Guardar logo',
        savePrivacyPolicy: 'Guardar Política de Privacidad',
        myCompany: 'Mi empresa',
        consumptionDetails: 'Detalles de consumo',
        categories: 'Categorias',
        consumptionDetailsShootingAnswer:
          'DETALLES DEL CONSUMO ENVÍOS/RESPUESTAS',
        channelDetailing: 'Detalles por canal',
        actionDetailing: 'Detalles por acción',
        titleListCategories: 'LISTA DE CATEGORIAS',
        titleListCategoriesGroup: 'LISTA DE GRUPOS DE CATEGORIAS',
        titleListTagsGroup: 'LISTA DE GRUPOS DE TAGS',
        placeholderNewGroupTag: 'Nuevo grupo de tags',
        listTags: 'LISTA DE TAGS',
        tagsGroup: 'GRUPO DE TAGS',
        customStatus: 'LISTA DE ESTADO PERSONALIZADO',
        customRules: 'LISTA DE REGLAS DE TRATAMIENTO',
        customFilters: 'LISTA DE FILTROS PERSONALIZADOS',
        placeholderStatus: 'Nuevo estado personalizado',
        placeholderRules: 'Nueva regla de funcionamiento',
        newTag: 'Nueva Tag',
        selectedTag: 'SELECIONE O GRUPO DE TAGS',
        newCategory: 'Nueva categoria',
        newCategoryGroup: 'Nuevo grupo de categoria',
        selectCategoryGroup: 'Seleccione el Grupo de Categorias',
        categoryGroup: 'Grupo de categoria',
        branch: 'Sucursal',
        ih2: 'IH2',
        addSubCategory: 'Add subcategoria',
        templates: 'Plantilla',
        custom: 'Creación / personalización de plantillas',
        descriptionCustom:
          'En esta pantalla puede crear plantillas compartidas con todos los usuarios de la plataforma para utilizarlas en las transacciones de sus clientes.',
        subject: 'Tema',
        sender: 'Remitente',
        descriptionTemplate:
          'Configure y guarde sus plantillas para que pueda volver a utilizarlas de forma rápida y cómoda.',
        myTemplates: 'Mis plantillas',
        descriptionMyTemplates:
          'Seleccione una de las siguientes plantillas para ver el formato del correo electrónico y realizar cambios si es necesario.',
        saveTemplates: 'Guardar plantillas',
        save: 'Salvar',
        updateTemplate: 'Actualizar plantilla',
        deleteTemplate: 'Borrar plantilla',
        labels: {
          collectionChannel: 'Canal de colecta',
          shoot: 'Envío',
          reminder: 'Recordatório',
          resend: 'Reenvío',
          replica: 'Réplica',
          totalShoots: 'Total de envíos',
          answers: 'Respuestas',
          action: 'Acción',
          sms: 'SMS',
          wpp: 'Whatsapp',
          active: 'Activo',
          name: 'Nombre',
          others: 'Otros',
          conversion: 'Tasa de conversión',
        },
        messages: {
          registerEmail: {
            title: 'E-mail Registrado!',
            description:
              'El nuevo e-mail de remitente fue registrado para la empresa!',
          },
          cost: {
            title: 'E-mail de la Empresa',
            description:
              'Al utilizar su e-mail como remitente, tendrá un costo adicional por mes, desea realmente habilitar esta opción?',
          },
          updateMetric: {
            title: 'Modificar métrica principal',
            description:
              'Seguro que desea cambiar su métrica principal para presentar los datos?',
          },
          updateMetricSucess: {
            title: 'Métrica Modificada!',
            description: 'Su métrica principla fue cambiada con éxito!',
          },
          updatePeriod: {
            title: 'Cambiar el período principal',
            description:
              '¿Está seguro de que desea cambiar su Período principal para ver datos?',
          },
          updatePeriodSucess: {
            title: '¡Periodo cambiado!',
            description: '¡Tu período principal ha sido cambiado con éxito!',
          },
          buttons: {
            btnCancel: 'Cancelar',
            btnUpdate: 'Modificar',
          },
          error: {
            title: 'Oops... Algo salió mal!',
            description: 'Error',
          },
          updateLogo: {
            title: 'Logo Cambiado!',
            description:
              'La página será recargada para visualizar los cambios...',
          },
          saveBranchRuleSuccess: {
            title: 'éxito!',
            description:
              'La Regla para la sucursal {branchDataName} fue registrada.',
          },
          saveBranchRuleError: {
            title: 'Error',
            description: 'Algo salió mal!',
          },
          invalidEmail: {
            title: 'Email inválido',
            description:
              'Introduzca una dirección de correo electrónico válida',
          },
          privacyPolicyUpdate: 'Su Política de Privacidad fue cambiada!',
          enableResurvey: {
            switchLabel: 'Habilitar la búsqueda',
            alertSuccess: {
              title: 'Éxito!',
              description:
                'La configuración de búsqueda se ha cambiado para su empresa.',
            },
          },
          duplicatedGroup: {
            title: 'Oops',
            description: 'Grupo de Categoria duplicada',
          },
          createdGroup: {
            title: 'Éxito',
            description: 'Grupo de Categoria creado con éxito!',
          },
          updatedGroup: {
            title: 'Éxito',
            description: 'Grupo de Categoria actualizado con éxito!',
          },
          deletedGroup: {
            title: 'Éxito',
            description: 'Grupo de Categoria eliminado con éxito!',
          },
          duplicatedCategory: {
            title: 'Oops',
            description: 'Categoria duplicada',
          },
          createdCategory: {
            title: 'Éxito',
            description: 'Categoria creada con éxito!',
          },
          updatedCategory: {
            title: 'Éxito',
            description: 'Categoria actualizada con éxito!',
          },
          deletedCategory: {
            title: 'Éxito',
            description: 'Categoria eliminada con éxito!',
          },
          updatedSubCategory: {
            title: 'Éxito',
            description: 'Subcategoría actualizada correctamente!',
          },
        },
        notification: {
          button: 'Notificación por correo electrónico',
          modalTitle: 'Notificación por correo electrónico',
          modalDescription:
            'Se le avisará mensualmente cuando el porcentaje de consumo de su cuenta alcance el 90% o más.',
          inputEmail:
            'Ingrese el correo electrónico que recibirá la notificación',
          enableNotification: 'Habilitar',
        },
        categoria: {
          removeTitle: 'Eliminar categoría',
          removeDescription:
            ' Todas las respuestas vinculadas a esa categoría se verán afectadas. ¿Desea continuar?',
          cancelDescription: 'Cancelar',
          deleteDescription: 'Eliminar',
          successTitle: '¡Éxito!',
          successDescription: '¡La categoría ha sido eliminada correctamente!',
        },
        subCategoria: {
          removeTitle: 'Eliminar subcategoría',
          removeDescription:
            ' Todas las respuestas vinculadas a esta subcategoría se verán afectadas. ¿Desea continuar?',
          cancelDescription: 'Cancelar',
          deleteDescription: 'Eliminar',
          successTitle: '¡Éxito!',
          successDescription: '¡La subcategoría se eliminó correctamente!',
        },
      },
      users: {
        name: 'Usuarios',
        email: 'E-mail',
        titleNewUser: 'NUEVO USUARIO',
        titleUpdateUser: 'Editar Usuario',
        titlePermissions: 'Permisos para {userName}',
        titleBranches: 'Sucursales',
        titleIh2: 'IH2',
        titleViewingProfile: 'Perfil de Visualización',
        titleActions: 'Acciones',
        placeholderNameUser: 'Nombre del usuario',
        placeholderEmailUser: 'E-mail del usuario',
        placeholderPhoneUser: 'Celular del usuario',
        placeholderPostUser: 'Cargo del usuario',
        placeholderPassUser: 'Contraseña del nuevo usuario',
        placeholderBranch: 'Digite la sucursal',
        placeholderHierarchy: 'Digite el nombre de la Jerarquía',
        placeholderSearch: 'Haga una busqueda...',
        placeholderProfileName: 'Nombre del Perfil',
        invalidFeedbackName: 'Por favor, informe el nombre del usuario.',
        invalidFeedbackEmail:
          'Por favor, introduce una dirección de correo electrónico válida.',
        invalidFeedbackPhone: 'Por favor, informe el celular del usuario.',
        invalidFeedbackPost: 'Por favor, informe el cargo del usuario.',
        invalidFeedbackProfile: 'Por favor, informe el perfil del usuario.',
        invalidFeedbackPass: 'Por favor, informe la contraseña del usuario.',
        invalidFeedbackSamePass: 'Las contraseñas deben ser iguales.',
        listActions: 'Lista de acciones',
        clear: 'Limpiar',
        buttonRegister: 'Registrar',
        buttonPermissons: 'Permisos',
        buttonSave: 'Guardar',
        buttonCancel: 'Cancelar',
        chooseOption: 'Elija una opción',
        securityPassword:
          'Por seguridad su contraseña de acceso no se mostrará en la plataforma, pero usted podrá editarla a cualquier momento',
        expiredSecurityPassword:
          'Por seguridad su contraseña de acceso debe ser cambiada',
        expiredSendEmail: 'Enviaremos un código al correo electrónico:',
        selectAll: 'Selecionar tudo',
        labels: {
          nameUser: 'Nombre',
          phone: 'Celular',
          post: 'Cargo',
          currentPassword: 'Contraseña Actual',
          confirmNewPassword: 'Confirmar la nueva contraseña',
          updatePassword: 'Modificar Contraseña',
          permission: 'Permisos',
          profile: 'Perfil',
          viewingProfile: 'Perfil de Visualización',
          passwordUser: 'Contraseña del nuevo usuario',
          repeatPassword: 'Repita la contraseña',
          user: 'Usuario',
          company: 'Empresa',
          lastLogin: 'Último Acceso',
          options: 'Opción',
          email: 'E-mail',
          telephone: 'Teléfono',
          responsible: 'Responsable por tratar',
          selectAll: 'Seleccionar Todo',
          branch: 'Sucursal',
          date: 'Fecha',
          enable: 'Habilitar',
          controlId: 'ControlId',
          actions: 'Acciones',
          groupAction: 'Grupo de Acciones',
          creationDate: 'Fecha de Creación',
          channel: 'Canal',
          status: 'Status',
          menu: 'Menu',
          master: 'Master',
          admin: 'Admin',
          analyst: 'Analista',
          other: 'Otro',
          none: 'Ninguno',
          accessPassword: 'Contraseña de Acceso',
          changeExpiredPassword: 'Actulizar Contraseña de Acceso',
          twoFactorText:
            'Su cuenta está protegida con autenticación de dos factores. Ingrese el código de verificación que se envió al correo electrónico:',
          menuModal: 'Menu {position}',
        },
        messages: {
          registerUser: {
            text: 'Usuario Registrado',
            description: 'El nuevo usuario fue registrado en el sistema!',
          },
          deleteUser: {
            text: 'Eliminar Usuario',
            description:
              'Seguro que desea eliminar {name} de la lista de usuarios?',
          },
          savedChanges: {
            text: 'Cambios Guardados!',
            description:
              'Las actualizaciones para el usuario {userName} fueron guardadas con éxito!',
          },
          failedUpdate: {
            text: 'Oops! Algo salió mal...',
            description:
              'Verificar el número del celular y e-mail del usuario e intente nuevamente.',
          },
          updatePermissions: {
            text: 'Error',
            description:
              'Hubo algún error al asignar las sucursales/jerarquías para el usuario. Por favor, intente nuevamente.',
          },
          editOk: {
            text: 'Cambios Guardados!',
            description1: 'Las actualizaciones para el usuario',
            description2: 'fueron guardadas con éxito!',
          },
          editError: {
            text: 'Oops! Algo salió mal...',
            description:
              'Verificar el número del celular y e-mail del usuario e intente nuevamente.',
          },
          editUser: {
            title: 'Usuario Editado',
            description: 'El perfil fue editado con éxito!',
          },
          incorrectData: {
            title: 'Datos Incorrectos',
            description: 'Por favor complete los campos correctamente.',
          },
          updatePassword: 'Contraseña actualizada con éxito!',
          performedAssignments: 'Asignaciones Realizadas!',
          newBranchesAssigned:
            'Las nuevas sucursales/jerarquias fueran asignadas al usuario.',
          error: 'Error',
          eightCharacters: 'Debe contener al menos ocho caracteres',
          containNumbers: 'Debe contener números',
          containCapitalLetters: 'Debe contener letras mayúsculas',
          containSpecialCharacters: 'Debe contener caracteres especiales',
        },
      },
      alertsNewsletters: {
        name: 'Alertas/Boletines',
        yes: 'Sí',
        no: 'No',
        editRule: 'Editar Regla',
        cancel: 'Cancelar',
        save: 'Guardar',
        alerts: 'Alertas',
        bulletin: 'Boletines',
        ruleBranch: 'Regla de Sucursal {branchDataName}',
        close: 'Cerrar',
        titleNewRule: 'NUEVA REGLA',
        titleGeneral: 'General',
        titleBranch: 'Sucursal',
        diary: 'DIARIO',
        monthly: 'MENSUAL',
        weekly: 'SEMANAL',
        yearly: 'ANUAL',
        none: 'Nada',
        buttonRegister: 'Registrar',
        buttonClear: 'Limpiar',
        placeholderRuleName: 'Digite el nombre de la regla',
        placeholderEmail: 'Digite el e-mail',
        placeholderStaggering: 'Digite el e-mail del escalonamiento',
        placeholderSearch: 'Haga una busqueda...',
        feedbackRuleName: 'Por favor, informe el nombre de la regla.',
        feedbackEmail: 'Por favor, informe el e-mail.',
        feedbackEmailUser: 'Por favor, informe el e-mail del usuario.',
        emailAlert: 'E-mails que recibirán alertas (por nota)',
        emailsAlertNote: 'E-mails que recibirán alertas (por nota)',
        alertNote: 'Recibirán alertas (por nota)',
        staggering: 'Escalonamiento',
        savedRules: 'Reglas guardadas',
        actions: 'Acciones',
        yesLabel: 'Sí',
        noLabel: 'No',
        table: {
          branch: 'Sucursal',
          hasAlert: 'Posee alerta?',
          updated: 'Fecha de actualización de regla',
          options: 'Opciones',
        },
        labels: {
          ruleName: 'Nombre de la regla',
          email: 'E-mail',
          onlyReplyComment: 'Apenas respuestas con comentario',
          levelOneEmail: 'E-mail Nivel 1',
          levelTwoEmail: 'E-mail Nivel 2',
          levelThreeEmail: 'E-mail Nivel 3',
          days: 'Dias',
          branch: 'Sucursal',
          haveAlert: 'Posee alerta?',
          ruleUpdateDate: 'Fecha de actualización de regla',
          options: 'Opciones',
          selectAllNotes: 'Seleccionar todas las notas',
        },
        messages: {
          insertNameRule: {
            title: 'Oops!',
            description: 'Por favor, ingrese un nombre para la regla!',
          },
          ruleForBranch: {
            title: 'Oops!',
            description:
              'Para exhibir las reglas por sucursal es necesário crear una regla principal, desea hacer esto?',
          },
          successRegisterRule: {
            title: 'Regla Registrada',
            description: 'La nueva regla fue registrada con éxito!',
          },
          handleDelete: {
            title: 'Está seguro(a)?',
            description:
              'Desea eliminar la regla de alerta para la sucursal {branchName}',
          },
          deleteRuleBrachSuccess: {
            title: 'Éxito!',
            description:
              'La regla para la sucursal {branchName} fue eliminada.',
          },
          updateRule: {
            title: 'Éxito!',
            description: 'La regla fue editada con éxito!',
          },
          deleteRuleQuestion: {
            title: 'Eliminar Regla',
            description: 'Seguro que desea eliminar esta regla de su lista?',
            cancel: 'Cancelar',
            delete: 'Eliminar',
            deletedOk: 'Regla eliminada con éxito!',
          },
          deleteBranchRule: {
            title: 'Está seguro(a)?',
            description:
              'Desea realmente eliminar la regla de alerta para la sucursal',
            deletedOkTitle: 'Éxito!',
            deletedOkMsg1: 'La regla para la sucursal',
            deletedOkMsg2: 'fue eliminada.',
          },
          enterNameRule: {
            title: 'Oops!',
            description: 'Por favor, ingrese un nombre para la regla.',
          },
          ruleRegistered: 'La regla {newRuleName} ya fue registrada.',
          pleaseInsertNameRule: 'Por favor, ingrese un nombre para la regla.',
        },
      },
      hierarchies: {
        name: 'Jerarquías',
        titleNewBranch: 'NUEVA SUCURSAL',
        titleUpdateBranch: 'Editar Sucursal',
        titleNewHierarchies: 'NUEVA JERARQUÍA',

        clear: 'Limpiar',

        placeholderNameBranch: 'Digite el nombre de la sucursal',
        placeholderEnterDescription: 'Digite la descripción',
        placeholderEnterGroup: 'Digite el grupo',
        placeholderEnterCode: 'Digite el código',
        placeholderCustomField: 'Campo Personalizado',
        placeholderValue: 'Valor',
        placeholderSearch: 'Haga una busqueda...',
        placeholderIh2: 'Ej.: Ventas, Posventa, etc.',

        buttonRegister: 'Registrar',
        buttonCancel: 'Cancelar',
        buttonRemove: 'Eliminar',
        buttonSave: 'Guardar',

        feedbackInformBranch: 'Por favor, informe la Sucursal.',
        feedbackInformDescription: 'Por favor, informe la descripción.',
        feedbackInformGroup: 'Por favor, informe el grupo.',
        feedbackInformCode: 'Por favor, informe el código.',
        feedbackInformHierarchiesName:
          'Por favor, informe el nombre de la jerarquía.',
        branchRemoved: 'Sucursal Eliminada!',
        hierarchyRemoved: 'Jerarquía Eliminada!',

        labels: {
          nameBranch: '*Sucursal',
          branch: 'Sucursal',
          creationDate: 'Fecha de Creación',
          options: 'Opciones',
          description: 'Descripción',
          group: 'Grupo',
          code: 'Código',
          customField: 'Campo Personalizado',
          value: 'Valor',
          hierarchiesName: '*Nombre de la Jerarquía',
          corporationName: 'Nombre',
        },
        messages: {
          succesAddBranch: {
            title: 'Sucursal Agregada',
            description: 'Una nueva sucursal fue creada!',
          },
          removeBranch: {
            title: 'Eliminar sucursal?',
            description: 'Desea realmente eliminar la sucursal seleccionada?',
          },
          changesSaved: {
            title: 'Cambios Guardados!',
            description: 'Los cambios fueron guardaos con éxito!',
          },
          succesAddHierarchy: {
            title: 'Jerarquía Registrada',
            description: 'Una nueva jerarquía fue registrada!',
          },
          removeHierarchy: {
            title: 'Eliminar Jerarquía?',
            description: 'Desea realmente eliminar la jerarquía seleccionada?',
          },
        },
      },
      accessProfile: {
        name: 'Perfil de acceso',
        profileList: 'LISTA DE PERFILES',
        buttonNewProfile: 'Nuevo perfil',
        myProfile: 'Mi perfil',
        newPassword: 'Digite la nueva contraseña',
        email: 'Email',
        profile: 'Perfil',
        telephone: 'Teléfono',
        updatePassword: 'Cambiar Contraseña',
        registerNewProfile: 'Registrar Nuevo Perfil',
        nameProfile: 'Nombre',
        buttonCancel: 'Cancelar',
        confirmNewPassword: 'Confirmar la nueva contraseña',
        nameUser: 'Nombre',
        registeredIn: 'Registrado en',
        lastLogin: 'Último Acceso',
        post: 'Cargo',
        buttonRemove: 'Eliminar',
        removed: 'Eliminado',
        removeProfile: 'Eliminar perfil',
        options: 'Opciones',
        editProfile: 'Editar perfil',
        personalInformation: 'Informaciones Personales',
        status: 'Status',
        informName: 'Por favor, informe el nombre',
        informEmail: ' Por favor, informe el e-mail.',
        informTelephone: 'Por favor, informe el teléfono.',
        informPost: 'Por favor, informe el cargo.',
        accessPassword: 'Contraseña de Acceso',
        securityPassword:
          'Por seguridad su contraseña de acceso no se mostrará en la plataforma, pero usted podrá editarla a cualquier momento',
        currentPassword: 'Contraseña Actual',
        messages: {
          editUser: {
            title: 'Usuario Editado',
            description: 'El perfil fue editado con éxito!',
          },
          updatePassword: 'Contraseña actualizada con éxito!',
        },
      },
      integrations: {
        name: 'Integraciones',
        titleZenvia: 'Zenvia',
        titleEnterPhone: 'Digite celular para prueba',
        titleStatus: 'Status de la integración',
        titleCollectResponse: 'Webhook - Colección de respuestas',
        titleCollectShoot: 'Webhook - Colección de shoot',
        titleApiKey: 'Clave de integración a través de API',
        integrationHabilit: 'Habilitar Integración',
        integrationTest: 'Testar Integración',
        required: 'Necesario: http:// ou https://',
        postUrl: 'HTTP Post URL',
        descriptionCollect:
          'Este evento permite la configuración de un punto final para recibir los datos recopilados en tiempo real de cada cliente.',
        descriptionModelReturn:
          'Consulte el modelo de devolución de información.',
        descriptionApi:
          'Puede utilizar la clave "empresa-clave" para utilizar las API de integración de Indecx. Consulte la documentación para obtener más detalles.',
        companyKey: 'Clave de la empresa',
        status: 'Status',
        integration: 'Integración',
        description: 'Descripción',
        enabled: 'Poder',
        descriptionZeenvia:
          'Utilice los créditos de SMS de su cuenta de Zeenvia para integrarse con Indecx fácil y rápidamente.',
        descriptionApiKey:
          'Habilite la opción para generar la clave de autenticación y habilite la opción de integración de API.',
        event: 'Evento',
        collectionAnswers: 'Colección de respuestas',
        collectDescription:
          'Registre un punto final para recibir las respuestas recopiladas por Indecx a tiempo.',
        loopDescription:
          'Registre un punto final para la recepción oportuna de las negociaciones realizadas cada vez que se completa el estado de un cliente.',
        phone: 'Teléfono',
        cancel: 'Cancelar',
        save: 'Guardar',
        userNameZenvia: 'Username zenvia',
        aggregateId: 'Aggregate Id',
        placeholderEnterUserName: 'Digite el username de la zenvia',
        placeholderEnterPass: 'Digite el password de la zenvia',
        placeholderEnterAggregateId: 'Digite el Aggregate Id',
        placeholderEnterUserTest: 'Digite el username del zenvia para prueba',
        placeholderEnterPasswordTest:
          'Digite el password del zenvia para prueba',
        placeholderAggregateIdTest: 'Digite el aggregate id para prueba',
        placeholderEnterPhone: 'Digite el celular para recibir el sms',
        feedbackInformUserName: 'Por favor, informe username.',
        feedbackInformPass: 'Por favor, informe password.',
        feedbackInformAggregateId: 'Por favor, informe Aggregate Id.',
        passwordLabel: 'Password zenvia',
        disabled: 'Desabilitado',
        lineOneDescription:
          'Usted puede utilizar los créditos de su cuenta Zenvia habilitando la integración de forma rápida.',
        lineTwoDescription:
          'Llene los campos abajo con los datos de su cuenta Zenvia, habilite la opción y listo.',
        lineThreeDescription:
          'Todos los SMSs enviados por la plataforma utilizarán el saldo de su cuenta Zenvia.',
        messages: {
          settingsSaved: {
            title: 'Configuración Guardada!',
            description:
              'La configuración de integración con Zenvia fue guardada con éxito!',
          },
          successSendSMS: {
            title: 'SMS enviado con éxito!',
            description: 'Éxito',
          },
          errorSettings: {
            title: 'Erro',
            description: 'Configuración incorrecta!',
          },
        },
      },
    },
    masterSettings: {
      titleNewCompany: 'NUEVA EMPRESA',
      titleEditCompany: 'Editar Empresa',
      titleNewUser: 'NUEVO USUARIO',
      titleAllCompanies: 'Todas las Empresas',
      titleAllUsers: 'Todos los Usuarios',
      titleReports: 'Reportes',
      titleNewReport: 'NUEVO REPORTE',
      logo: 'Logo',
      master: 'Master',
      admin: 'Admin',
      analyst: 'Analista',
      adminAccess: 'Admin access',
      ops: 'Oops!',
      general: 'General',
      segments: {
        foodDrinks: 'Alimentos y Bebidas',
        artAntiques: 'Arte y Antiguedades',
        religiousArticles: 'Articulos Religiosos',
        subscriptionsMagazines: 'Suscripciones y Revistas',
        automobilesVehicles: 'Automóviles y Vehículos',
        babiesCompany: 'Bebes y Cia',
        giftsPromotionalMaterials: 'Regalos / Materiales Promocionales',
        toysGames: 'Juguetes y Games',
        houseDecoration: 'Casa y Decoración',
        collectibles: 'Coleccionables',
        coletiveShopping: 'Compras Colectivas',
        constructionTools: 'Construcción y Herramientas',
        cosmeticsPerfumery: 'Cosméticos y Perfumeria',
        coursesEducation: 'Cursos y Educación',
        vinylsDiscs: 'Discos de Vinil',
        homeAppliances: 'Electrodomésticos',
        electronics: 'Electronicos',
        radioBroadcasters: 'Emisoras de Rádio',
        televisionBroadcasters: 'Emisoras de Televisión',
        jobs: 'Empleos',
        telemarketingCompanies: 'Empresas de Telemarketing',
        sportsLeisure: 'Deporte y Lazer',
        flowersBasketsGifts: 'Flores, Canastas y Regalos',
        photography: 'Fotografia',
        churchesTemplesReligiousInstitutions:
          'Iglesias / Templos / Instituiciones Religiosas',
        industryCommerceBusiness: 'Industria, Comercio y Negocios',
        promotionalInflatables: 'Inflables Promocionales',
        computing: 'Informática',
        tickets: 'Entradas',
        musicalInstruments: 'Instrumentos Musicales',
        jewelry: 'Joyería',
        recreation: 'Lazer',
        books: 'Libros',
        fashionAccessories: 'Moda y Accesórios',
        digitalMusic: 'Música Digital',
        businessOpportunities: 'Negocios y Oportunidades',
        otherServices: 'Otros Servicios',
        stationeryOffice: 'Papelería y Oficina',
        easter: 'Páscua',
        petShop: 'Pet Shop',
        cheers: 'Salud',
        advocacyService: 'Servicio de Abogados',
        newspaperMagazineDistributionService:
          'Servicio de Distribución de Periódicos / Revistas',
        administrativeServices: 'Servicios Administrativos',
        artisticServices: 'Servicios Artísticos',
        airportServices: 'Servicios de Aeropuertos',
        agencyServices: 'Servicios de Agencias',
        rentalLeasingServices: 'Servicios de Alquiler / Arriendo',
        warehousingServices: 'Servicios de Almacén',
        advisoryServices: 'Servicios de Asesoramiento',
        technicalAssistanceServicesFacilities:
          'Servicios de Assistencia Técnica / Instalaciones',
        associationServices: 'Servicios de Asociaciones',
        bloodBankServices: 'Servicios de Bancos de Sangre',
        libraryServices: 'Servicios de Bibliotecas',
        notaryServices: 'Servicios de Registraduría',
        lotteryServices: 'Servicios de Casas Lotérias',
        clothingServices: 'Servicios de Confecciones',
        consortiumServices: 'Consorcio de Servicios',
        consultingServices: 'Servicios de Consultorias',
        cooperativeServices: 'Servicios de Cooperativas',
        dispatcherServices: 'Servicios Agente de despacho',
        engineeringServices: 'Servicios de Ingenieria',
        parkingServices: 'Servicios de Estacionamientos',
        shipyardServices: 'Servicios de Astilleros',
        exportImportServices: 'Servicios de Exportación / Importación',
        geologistServices: 'Servicios de Geólogos',
        jewelerServices: 'Servicios de Joyeros',
        auctioneerServices: 'Servicios de Subasta',
        cleaningServices: 'Servicio de Limpieza',
        convenienceStoreServices: 'Servicio de Tienda de Conveniencia',
        laborServices: 'Servicios de Mano de Obra',
        publicOrganServices: 'Servicios de Organos Públicos',
        researchServices: 'Servicios de Encuestas',
        portServices: 'Servicios de Puertos',
        healthWellnessServices: 'Serviços de Saúde / Bem Estar',
        insuranceServices: 'Servicios de Aseguradoras',
        securityServices: 'Servicios de Seguridad',
        signalingServices: 'Servicios de Señalización',
        unionFederationServices: 'Servicios de Sindicatos / Federaciones',
        translationServices: 'Servicios de Traducciones',
        transportServices: 'Servicios de Transporte',
        publicUtilityServices: 'Servicios de Utilidad Pública',
        servicesAgricultureLivestockFishFarming:
          'Servicios en Agricultura / Ganado / Piscicultura',
        foodServices: 'Servicios en Alimentacion',
        servicesArt: 'Servicios en Arte',
        communicationServices: 'Servicios en Comunicación',
        constructionServices: 'Servicios en Construcción',
        ecologyEnvironmentServices: 'Servicios en Ecologia / Medio Ambiente',
        servicesElectronicsMetalMechanics:
          'Servicios en Electroeletronica / Metal Mecanica',
        partyEventServices: 'Servicios en Fiestas / Eventos',
        computerServices: 'Servicios en Informática',
        internetServices: 'Servicios en Internet',
        jeweleryWatchesOpticalServices: 'Servicios en Joyas / Relog / Optica',
        technologyServices: 'Servicios en Tecnologia',
        telephonyServices: 'Servicios en Telefonia',
        vehicleServices: 'Servicios en Vehículos',
        esotericMysticalServices: 'Servicios Exotéricos / Místicos',
        financialServices: 'Servicios Financieros',
        funeralServices: 'Servicios Funerales',
        generalServices: 'Servicios Generales',
        graphicEditorialServices: 'Servicios Gráficos / Editoriales',
        animalServices: 'Servicios para Animales',
        servicesDisabled: 'Servicios para Discapacitados',
        officeServices: 'Servicios para Oficinas',
        clothingForServices: 'Servicios para Ropas',
        socialAAssistanceServices: 'Servicios Sociales / Asistenciales',
        shoppingCenters: 'Shopping Centers',
        tobacconist: 'Tienda de Tabaco',
        bankFee: 'Comisiones Bancarias',
        telephoneCharges: 'Comisiones Telefonicas',
        telephony: 'Telefonia',
        tourism: 'Turismo',
      },
      specific: 'Específico',
      clear: 'Limpiar',
      noUserRegistered: 'Ningún usuario registrado para esta empresa.',
      removedReport: 'Reporte eliminado',
      removedCompany: 'Empresa eliminada',
      buttonRegister: 'Registrar',
      buttonSave: 'Guardar',
      buttonCancel: 'Cancelar',
      placeholderCorporationName: 'Razón Social',
      placeholderCompanyName: 'Nombre de la empresa',
      placeholderUserName: 'Nombre del usuario',
      placeholderPhone: 'Celular del usuario',
      placeholderCnpj: 'NIT/CUIT de la empresa',
      placeholderCountry: 'País de la empresa',
      placeholderReference: 'Indicador de Fecha de Referéncia',
      placeholderPassword: 'Contraseña del nuevo usuario',
      placeholderSequence: 'Digite el segmento...',
      placeholderLogo: 'Elija el logo de la empresa',
      placeholderDropFile: 'Suelte el archivo aqui...',
      placeholderEmail: 'E-mail del usuario',
      placeholderSearch: 'Haga una busqueda...',
      placeholderPostUser: 'Cargo del usuario',
      placeholderReportsName: 'Nombre del reporte',
      feedbackInformCorporationName:
        'Por favor, informe la razón social de la empresa.',
      feedbackInformCompanyName: 'Por favor, informe el nombre de la empresa.',
      feedbackInformCnpj: 'Por favor, informe el NIT/CUIT de la empresa.',
      feedbackInformSequence:
        ' Por favor, informe el seguimento de la empresa.',
      feedbackInformPass: 'Por favor, informe la contraseña del usuario.',
      feedbackInformReport: 'Por favor, informe el nombre del reporte.',
      feedbackInformBalance:
        'Para el plan personalizado, es necesario informar los saldos.',
      feedbackInformNameUser: 'Por favor, informe el nombre del usuario.',
      feedbackInformEmail: 'Por favor, informe el e-mail del usuario.',
      feedbackInformPhone: 'Por favor, informe el celular del usuario.',
      feedbackInformPost: 'Por favor, informe el cargo del usuario.',
      feedbackSamePass: 'Las contraseñas deben ser iguales.',
      channelOptions: {
        demo: 'Demo',
        basic: 'Básico',
        intermediate: 'Intermedio',
        advanced: 'Avanzado',
        custom: 'Personalizado',
        dev: 'Dev',
      },
      labels: {
        companyName: 'Razón Social',
        fantasyName: 'Nombre Fantasia',
        cnpj: 'NIT/CUIT',
        country: 'Pais',
        referenceDate: 'Indicador de fecha de referéncia',
        sequence: 'Segmento',
        plan: 'Plan',
        companyLogo: 'Logo de la Empresa',
        smsMonth: 'SMS/Mes',
        emailMonth: 'E-mail/Mes',
        email: 'E-mail',
        name: 'Nombre',
        limit: 'Limite',
        quantityEmail: 'Cant. E-mail',
        quantitySms: 'Cant. SMS',
        options: 'Opciones',
        company: 'Empresa',
        phone: 'Teléfono',
        post: 'Cargo',
        profile: 'Perfil',
        passwordUser: 'Contraseña del nuevo usuario',
        repeatPassword: 'Repita la contraseña',
        user: 'Usuario',
        lastAcess: 'Último Acceso',
        application: 'Aplicación',
        client: 'Cliente',
        activate: 'Activar',
        report: 'Reporte',
        actions: 'Acciones',
        sentiment: 'Habilitar análisis de sentimiento',
        enableAttach: 'Permitir subir (archivos) tratativas',
        enableAudioResponse: 'Permitir grabar audio en las respuestas',
        channelTotem: 'Habilitar tótem',
        channelCallCenter: 'Habilitar Click-to-call (Centro de llamadas)',
        privacyPolicy: 'Habilitar Política de Privacidad via link',
      },
      messages: {
        removeCompany: {
          title: 'Eliminar Empresa',
          description: 'Seguro(a) de eliminar la empresa?',
        },
        addCompany: {
          title: 'Empresa Registrada',
          description: 'La nueva empresa fue registrada en el sistema!',
        },
        error: {
          title: 'Error',
          description:
            'Hubo un error el registrar el cliente. Verificar los campos y su internet e intente nuevamente más tarde.',
        },
        successAddUser: {
          title: 'Usuario Registrado',
          description: 'El nuevo usuario fue registrado en el sistema!',
        },
        selectCompany: {
          title: 'Oops...',
          description: 'Seleccione una empresa para el usuario.',
        },
        userMaster: {
          title: 'Oops...',
          description:
            'Usuarios del tipo Master deben ser de la empresa IndeCX obligatoriamente.',
        },
        removeUser: {
          title: 'Eliminar Usuario',
          description:
            'Seguro(a) que desea eliminar {nameUser} de la lista de usuarios?',
        },
        changeOrderList: {
          title: 'Éxito!',
          description: 'Orden de reportes alterada!',
        },
        addReport: {
          title: 'Éxito!',
          description: 'Reporte registrado.',
        },
        removeReport: {
          title: 'Eliminar reporte',
          description: 'Seguro(a) de eliminar el reporte?',
        },
      },
    },
    filter: {
      filters: 'Filtros',
      filterAactionGroup: 'Filtro por grupo de acciones',
      filterAction: 'Filtro por acción',
      provincialMetric: 'Métrica Principal',
      NPS1a5: 'NPS de 1 a 5',
      NPS010: 'NPS de 0 a 10',
      CES1a10: 'CES de 1 a 5',
      CES1a5: 'CES de 1 a 5',
      CSAT1to5: 'CSAT de 1 a 5 (Top 2 box)',
      CSAT1to5Average: 'CSAT de 1 a 5 (Média)',
      CSAT0to10Average: 'CSAT de 0 a 10 (Média)',
      review5Stars: 'REVIEW - 5 Stars',
      likeDislike: 'Like/Dislike - 0 e 1',
      metricsUnavailable: 'Métricas indisponibles',
      titleResetFilter: 'Restaurar filtro del indicador',
      titleResetFilterData: 'Restaurar filtro de datos del indicador',
      conclude: 'Aplicar y cerrar',
      clearFilter: 'Limpiar Filtros',
      loading: 'Cargando...',
      indicators: 'Datos del indicador - {indicatorData}',
      indicatorData: 'Datos del indicador',
      filterIh1: 'Filtro por - {ih1} ',
      filterIh2: 'Filtro por - {ih2} ',
      boxIndicator: 'Indicador - {indicatorName}',
      indicator: 'Indicador',
    },
    sidebar: {
      dashboard: 'Dashboard',
      actions: 'Acciones',
      actionList: 'Lista de Acciones',
      newAction: 'Nueva Acción',
      actionGroup: 'Grupo de Acciones',
      answers: 'Respuestas',
      answersList: 'Lista Respuestas',
      sentiment: 'Análisis Sentimiento',
      manualAnswer: 'Respuesta Manual',
      categorization: 'Categorización',
      categorizationAdditional: 'Categorización Input',
      invites: 'Envíos',
      resend: 'Reenvío',
      reminders: 'Recordatórios',
      scheduling: 'Agendamientos',
      treatments: 'Tratativas',
      individual: 'Apartado',
      bulk: 'Bulk',
      reports: 'Reportes',
      reportsList: 'Lista de Reportes',
      clients: 'Clientes',
      clientsList: 'Lista Clientes',
      files: 'Archivos',
      downloads: 'Downloads',
      uploads: 'Uploads',
      reccycleBin: 'Papelera',
      version: 'Versión',
      quarentine: 'Cuarentena',
      resendwpp: 'Whatsapp',
      treatmentsReview: 'Revisão',
      aiAnalysis: 'Análisis IA',
    },
    navbar: {
      nps15: 'NPS 1 a 5',
      nps010: 'NPS 0 a 10',
      ces15: 'CES 0 a 10',
    },
    profile: 'Perfil',
    leave: 'Salir',
  },
  dashboard: {
    action: 'Acción',
    period: 'Período',
    brasil: 'Brasil',
    portugues: 'Português',
    ingles: 'English',
    colombia: 'Colombia',
    espanhol: 'Español',
    eua: 'Estados Unidos',
    all: 'Todos',
    invites: 'Invitaciones',
    customers: 'Clientes',
    answers: 'Respuestas',
    responsesRate: 'Tx. Respuestas',
    totalResponseRate: 'Tx. Respuestas Total',
    digitalResponseDate: 'Tx. Respuestas Digital',
    groupActions: 'Grupo de acciones',
    metric: 'Métrica',
    stockComparison: 'Comparativo de acciones',
    updateList: 'Actualizar lista',
    todayFilter: 'Hoy',
    yesterdayFilter: 'Ayer',
    last30DaysFilter: 'Últimos 30 días',
    currentMonthFilter: 'Mes actual',
    lastMonthFilter: 'Mes pasado',
    currentYearFilter: 'Año corriente',
    lastYearFilter: 'El año pasado',
    everyPeriodFilter: 'Todo el Período',
    custom: 'Personalizado',
    CCSI: 'CCSI',
    HGSI: 'HGSI',
    PREHGSI: 'PRE-HGSI',
    FCSI: 'FCSI',
    labelsStockComparison: {
      actionName: 'Nombre de la acción',
      answers: 'Respuestas',
      promoters: '% Promotores',
      neutral: '% Neutros',
      detractors: '% Detractores',
      nps: 'NPS',
      conversionRate: 'Tasa de conversión',
      invites: 'Invitaciones',
    },
  },
  actionList: {
    pageTitle: 'Lista de acciones',
    newActionButton: 'Nueva acción',
    searchInput: 'Haga una busqueda...',
    searchButton: 'Limpiar',
    registerGroupAction: 'Registre un grupo',
    veryUnsatisfied: 'Muy insatisfecho',
    here: 'Aqui.',
    loading: 'Cargando...',
    updateList: 'Actualizar Lista',
    nps010: 'NPS 0 a 10',
    nps15: 'NPS 1 a 5',
    csat15: 'CSAT 1 a 5 (Top 2 box)',
    csat15Average: 'CSAT 1 a 5 (Média)',
    csat0to10Average: 'CSAT 0 a 10 (Média)',
    likeDislike: 'Like/Dislike - 0 e 1',
    fiveStars: 'Reseñas - 5 estrellas',
    both: 'ambos',
    details: 'Detalles',
    edit: 'Editar',
    send: 'Enviar',
    clone: 'Clonar Acción',
    remove: 'Eliminar',
    executed: 'Ejecutado en',
    scheduled: 'Agendado para',
    registerEmail: 'Registrar Email (remitente)',
    registerWebhook: 'Registrar webhook',
    required: 'Requerido: http:// ou https://',
    saveWebhook: 'Salvar',
    testIntegration: 'Prueba de integración',
    habilitIntegration: 'Habilitar la integración',
    messages: {
      remove: {
        title: 'Eliminando una Acción',
        description: `Seguro(a) que desea eliminar esta acción?
                     Esto puede afectar directamente el cálculo de su NPS.`,
        okLabel: 'Eliminar',
        cancelLabel: 'Cancelar',
      },
      removeOk: {
        title: 'Acción Eliminada!',
        description:
          'Su NPS está siendo recalculado, esto podrá demorar algunos minutos.',
      },
      clone: {
        title: 'Clonando una Acción',
        description:
          'Usted está prestes a duplicar las configuraciones de esta acción, desea continuar?',
        okLabel: 'Duplicar',
        cancelLabel: 'Cancelar',
      },
      cloneOk: {
        title: 'Acción duplicada!',
        description:
          'Todas las configuraciones de la acción fueron duplicadas.',
      },
    },
    actionTable: {
      labels: {
        id: 'ID',
        action: 'Acción',
        group: 'Grupo de acciones',
        categoryGroup: 'Grupo de categoria',
        type: 'Tipo',
        date: 'Fecha de creación',
        channel: 'Canal',
        registers: 'Registros',
        quarentine: 'Cuarentena',
        valids: 'Válidos',
        failures: 'Fallas',
        answers: 'Respuestas',
        status: 'Status',
        options: 'Opciones',
      },
      noClassifiedLabel: 'Sin clasificación',
      status: {
        criado: 'creado',
        processando: 'procesando',
        enviando: 'enviando',
        enviado: 'enviado',
        agendado: 'agendado',
        falha: 'falla',
        bloqueado: 'bloqueado',
        importando: 'importador',
        importado: 'importado',
      },
    },
    actionDetails: {
      details: 'Detalles de la acción',
      cleanInput: 'Limpiar',
      placeholderSearch: 'Haga una busqueda...',
      actionFilterStatus: {
        select: 'Filtro por status',
        all: 'Todos',
        processando: 'Procesando',
        enviando: 'Enviando',
        enviado: 'Enviado',
        respondido: 'Respondido',
        quarentena: 'Cuarentena',
        duplicado: 'Duplicado',
        bloqueado: 'Obstruido',
        falha: 'Falla',
        importando: 'Importando',
        importado: 'Importado',
      },
      labels: {
        id: 'ID',
        name: 'Nombre',
        email: 'E-mail',
        phone: 'Teléfono',
        date: 'Fecha de Envío',
        days: 'Dias',
        channel: 'Canal',
        emailStatus: 'Val. E-mail',
        phoneStatus: 'Val. Teléfono ',
        status: 'Status',
      },
      titleExportCSV: 'Exportar para CSV',
      titleExportXLS: 'Exportar para XLS',
      alertsActionDetails: {
        succes: {
          title: 'Éxito!',
          description:
            'El archivo está siendo preparado! Usted puede acompañar el status de procesamiento en el menu "Downloads".',
        },
      },
      notAnswered: 'No respondido',
      answered: 'Respondido',
      valid: 'válido',
      invalid: 'inválido',
    },
    resurveyModal: {
      title: 'Configurar la regla de búsqueda',
      cancelButton: 'Cancelar',
      saveButton: 'Guardar notas',
      description:
        'Seleccione a continuación qué acciones del tipo "búsqueda" desea aplicar al proceso de búsqueda...',
      gradesDescription:
        '¿Para qué calificación le gustaría enviar la encuesta al cliente?',
      tableLabels: {
        name: 'Acción',
        actionGroup: 'Grupo de acciones',
        createdAt: 'Fecha de creación',
        channel: 'Canal',
        resurvey: 'Habilitar búsqueda',
      },
    },
  },
  newAction: {
    modalTitle: 'Nueva acción',
    createAction: 'Crear acción',
    stepsLabels: {
      selectMetric: 'Métrica principal',
      stepOne: 'Crear acción',
      stepTwo: 'Configuración',
      stepThree: 'Importar datos',
    },
    templateHTML: `<p>Gracias por elegir nuestra empresa. <br> </p>
                  <p>Nos encantaria perfeccionar su experiencia con nuestros servicios a través de este
                  cuestionário que dura apenas 60 segundos.
                  <br>
                  </p>
                  <p>Apreciamos su colaboración.<br></p>`,
    closeHTML: '<p> ¡Gracias por completar nuestra encuesta! </p>',
    dynamicClosingMessage: 'Cierre dinámico',
    dynamicClosingMessageText: {
      part1:
        'Puede personalizar el mensaje de cierre de acuerdo con la nota asignada por el cliente.',
      part2:
        'Seleccione la escala de notas a continuación y personalice el diseño de la página',
    },
    closingMessageGrades: {
      zeroToTen: {
        promoters: 'Notas 10 y 9',
        passives: 'Notas 8 y 7',
        detractors: 'Notas 6 a 0',
      },
      oneToFive: {
        promoters: 'Notas 5 y 4',
        passives: 'Nota 3',
        detractors: 'Notas 2 y 1',
      },
      zeroAndOne: {
        promoters: 'Nota 1',
        passives: '',
        detractors: 'Notas 0',
      },
    },
    autoReplyGrades: {
      zeroToTen: {
        promoters: 'Notas 10 y 9',
        passives: 'Notas 8 y 7',
        detractors: 'Notas 6 a 0',
      },
      oneToFive: {
        promoters: 'Notas 5 y 4',
        passives: 'Nota 3',
        detractors: 'Notas 2 y 1',
      },
    },
    buttonReturn: 'Volver',
    buttonSave: 'Guardar Acción',
    buttonSaveConfig: 'Guardar Configuraciones',
    buttonSaveAndExit: 'Guardar y Cerrar',
    nameAction: 'NOMBRE DE LA ACCIÓN',
    answerSurvey: 'Responda nuestra encuesta aqui:',
    anonymousAnswer: 'Quiero responder de forma anónima',
    selectMetric: {
      pageTitle: 'Escoja su métrica principal',
      button: {
        selectLabel: 'Seleccionar',
        soonLabel: 'En breve',
      },
      nps: {
        title: 'Quiere saber que es NPS?',
        description:
          'NPS, sigla de Net Promoter System o Net Promoter Score, es un indicador de fidelidad y satisfacción de clientes muy utilizado mundialmente. El mide, a través de apenas una pregunta, cual es el nivel de fidelidad y satisfacción de los clientes con una empresa, servicio o producto.',
      },
      ces: {
        title: 'Quieres saber qué es CES?',
        description:
          'El Customer Effort Score(CES) o el índice de esfuerzo del cliente (IEC) es un indicador clave de rendimiento (KPI) para medir cuánto esfuerzo debe realizar un cliente para obtener una respuesta o solución a un problema. Básicamente, se utiliza para crear una experiencia sin esfuerzo para los clientes.',
      },
      csat: {
        title: 'Quiere saber que es CSAT?',
        description:
          'El Customer Satisfaction Score (CSAT) es una métrica que muestra el grado de satisfacción del cliente con una empresa, un producto o un servicio. El CSAT es una metodologia bastante popular principalmente por la forma descomplicada de medir las respuestas colectadas.',
      },
      likert: {
        title: 'Quiere saber que es Likert?',
        description: `Escala Likert, métrica proyectada para medir las actitudes, opiniones o percepciones de las personas. Los clientes eligen entre una variedad de respuestas posibles lo que más refleja su opinión como "Muy Satisfecho", "Satisfecho", "Indiferente", "Insatisfecho" y "Muy insatisfecho".`,
      },
      reviews: {
        title: 'Quiere saber que es Reviews?',
        description:
          "5 Star Rating quizás sea la métria más común y presente en nuestro día a día, utilizada por muchas empresas en los sectores de transporte por aplicativo, delivery's, bancos etc... Ella permite una evaluación de forma más visual (estrellas) y el resultado es cálculado a través de un promedio ponderado.",
      },
      likeDislike: {
        title: 'Quiere saber que es like/dislike?',
        description:
          'Conocido como Me gusta/No me gusta o Me gusta/No me gusta, es una excelente opción para analizar los comentarios en la mayoría de los casos, directo posible, ya que es una métrica muy común utilizada en varias aplicaciones que utilizo a diario para la evaluación.',
      },
    },
    stepOne: {
      labels: {
        actionName: 'Nombre de la acción',
        scale: 'Escala',
        methodology: 'Metodologia',
        collectionCanal: 'Canal de colecta',
        actionType: 'Tipo da ação',
        surveyType: 'Pesquisa',
        resurveyType: 'Repesquisa',
        question: 'Pergunta',
        infoQuestion:
          'Para cambiar la pregunta principal, haga clic en la opción de edición de la plantilla principal (icono de lapislázuli)',
        replicas: 'Réplicas',
        commentOrder: 'Orden del comentario',
        afterAdditionalQuestion: 'Después de la pregunta adicional',
        beforeAdditionalQuestion: 'Antes de la pregunta adicional',
        additionalQuestion: 'Pregunta adicional',
        addQuestion: 'Pregunta adicional?',
        smsQuestion: 'Pregunta en SMS',
        csatScale: 'CSAT - escala de 1 a 5 (Top 2 box) ',
        csatScaleAverage: 'CSAT - escala de 1 a 5 (promedio)',
        csatScaleAverage0to10: 'CSAT - escala de 0 a 10 (promedio)',
        fiveStars: 'Revisión - 5 estrellas',
        likeDislike: 'Like/Dislike - 0 e 1',
        able: 'Habilitado',
        chooseOption: 'Elija una opción',
        settingSMS: 'Configuración de SMS',
        openFieldPromoters9a10: 'Campo abierto para promotores (notas 9 y 10)',
        openFieldPassives7e8: 'Campo abierto para neutros (notas 7 y 8)',
        openFieldDetractors0a6: 'Campo abierto para detractores (notas 0 a 6)',
        openFieldPromoters4e5: 'Campo abierto para promotores (notas 4 y 5)',
        openFieldPassives3: 'Campo abierto para neutros (nota 3)',
        openFieldDetractors1e2: 'Campo abierto para detractores (notas 1 y 2)',
        openFieldCESPromoters4e5: 'Campo abierto para notas 4 y 5',
        openFieldCESPassives3: 'Campo abierto para nota 3',
        openFieldCESDetractors1e2: 'Campo abierto para notas 1 y 2',
        sms: 'Escriba el mensaje para el enlace de la encuesta:',
        openFieldCSAT4and5: 'Campo abierto para notas 4 y 5',
        openFieldCSAT3: 'Campo abierto para nota 3',
        openFieldCSAT1and2: 'Campo abierto para notas 1 y 2',
        openField5Stars4and5: 'Campo abierto para promotores (notas 4 y 5)',
        openField5Stars3: 'Campo abierto para neutros (nota 3)',
        openField5Stars1and2: 'Campo abierto para detractores (notas 1 y 2)',
        openFieldLikeDislike1: 'Campo abierto para promotores (nota 1)',
        openFieldLikeDislike0: 'Campo abierto para detractores (nota 0)',
        english: 'Inglés',
        spanish: 'Español',
        portuguese: 'Portugués',
        modalTranslationAddQuestion:
          'Al configurar la traducción de preguntas adicionales, los encuestados podrán elegir su idioma preferido para responder a la encuesta.',
        modalTranslationReplies:
          'Al configurar la traducción de las respuestas, los encuestados podrán elegir su idioma preferido para responder a la encuesta.',
      },
      saveChanges: 'Guardar cambios',
      radioOptions: {
        email: 'E-mail',
        sms: 'SMS',
        emailSMS: 'E-mail/SMS',
      },
      infoComment:
        'Al habilitar esta opción, un campo de comentarios estará disponible para que el cliente agregue una nota específica sobre esta pregunta adicional.',
      searchLink: 'Encuesta con link en SMS',
      searchBody: 'Encuesta en el cuerpo del SMS',
      veryUnsatisfied: 'Muy insatisfecho',
      points0a10: '0 a 10 puntos',
      yes: 'SÍ',
      email: 'E-mail',
      sms: 'SMS',
      emailSMS: 'E-mail/SMS',
      doNotExclude: 'NO ELIMINAR',
      detractorsSMS: 'Detractores',
      promotersSMS: 'Promoteres',
      placeholderDetractor: 'Digite la réplica para los detractores',
      placeholderNeutral: 'Digite la réplica para los neutros',
      placeholderPromoter: 'Digite la réplica para los promotores',
      placeholderEnterSubjectSMS: 'Digite el asunto del sms',
      placeholderTextLink: 'Texto para el link',
      placeholderTextBody: 'Texto en el cuerpo del Mensaje',
      altCellPhone: 'celular',
      selectTitle: 'Seleccionar {selectTemplate}',
      neutralSMS: 'Neutros',
      actionName: 'Informe el nombre de la acción',
      actionCSATName: 'Nueva acción CSAT',
      action5StarsName: 'Nueva acción 5-Stars',
      actionNameSize: 'No puede exceder más de 35 caracteres.',
      actionInvalid: 'Por favor, informe el nombre de la acción.',
      actionSavedAlert: 'Acción Guardada!',
      skipSettings: 'Avanzar Para Configuraciones',
      promoters: 'Que le motivó a dar esta nota?',
      neutral: 'En su opinión, qué faltó para ganarnos la nota máxima?',
      detractors: 'En su opinión, cuáles items deben ser mejorados?',
      surveyLayout: 'Layout de la Encuesta',
      editorLanguage: 'es',
      sender: 'Remitente',
      feedbackSender: 'Informe el remitente',
      subjectMatter: 'Asunto',
      template: 'Modelo',
      buttonAddTemplate: 'Adicionar modelo',
      topLogo: 'Logo superior',
      changeLogo: 'Elegir otro logo',
      buttonChooseFile: 'Elegir archivo',
      noFileSelected: 'Ningún archivo selcecionado',
      closingMessageInput: 'Msg de cierre',
      privacyPolicyInput: 'Política de privacidad',
      anonymousResponseInput: 'Respuesta anónima',
      anonymousSwitch: 'Habilitar anónimo',
      alwaysAnonymousSwitch: 'Habilitar siempre anónimo',
      addEmail: 'Agregar correo electrónico',
      sendTestEmail: 'Enviar',
      modalTestSurvey:
        'Valide su diseño antes de enviarlo a sus clientes! Complete su correo electrónico y vea cómo sus clientes recibirán su correo electrónico personalizado.',
      footerInput: 'Pie de página',
      scale0a10:
        'En una escala de 0 a 10, cuanto usted recomendaría a {companyName} para un amigo o familiar?',
      scale1a5:
        'En una escala de 0 a 5, cuanto usted recomendaría a {companyName} para un amigo o familiar?',
      scaleCSAT1to5:
        'En una escala del 1 al 5, ¿cuál es su grado de satisfacción con nuestra empresa?',
      scaleCSAT0to10:
        'En una escala del 0 al 10, ¿cuál es su grado de satisfacción con nuestra empresa?',
      question5Stars: 'Cómo califica el servicio prestado?',
      questionLikeDislike:
        'Cómo califica su experiencia con el servicio brindado?',
      newTemplateEmail: 'Nuevo Modelo de E-mail',
      selectSavedTemplate: 'Seleccionar modelo guardado',
      feedbackSaveTemplate: 'Informe un nombre para guardar su modelo',
      enterNameTemplate: 'Informe un nombre para el modelo',
      saveButton: 'Guardar',
      createdSucess: 'Modelo creado con éxito.',
      cancelButton: 'Cancelar',
      preview: 'Preview',
      scaleNps0a10: 'NPS - escala de 0 a 10',
      scaleNps1a5: 'NPS - escala de 1 a 5',
      editButton: 'Editar',
      titleTestLayoutEmail: 'Probar diseño de correo electrónico',
      bodyButtonMsg:
        'El botón abajo existirá solamente en el cuerpo del e-mail.',
      rateExperience: 'Califica tu experiencia',
      enterSubject: 'Informe un asunto',
      scaleButton: 'Escala',
      scaleBorder: 'Bordes',
      scaleGrade: 'Texto botón',
      scaleLargeButton: 'Botón',
      scaleButtonselected: 'Selección',
      scaleBackground: 'Fundo',
      scaleBackgroundText: 'Texto',
      scaleActiveText: 'Texto botón selecionado',
      messageError: {
        title: 'Oops! Algo salió mal...',
        description:
          'Su empresa no posee una Política de Privacidad. Guarde su acción y navegue hasta el menu configuraciones para registrarla.',
        errorEditAction:
          'Algo salió mal al momento de la edición de la acción. Por favor, verificar los datos e intente nuevamente.',
        errorCreateAction:
          'Algo salió mal al momento de la creación de la acción. Por favor, verificar los datos e intente nuevamente.',
        errorExceed: 'El mensaje alcanzó el límite de caracteres.',
      },
      testEmail: {
        title: 'Éxito',
        description: 'El correo electrónico de prueba se envió correctamente!',
      },
      invalidEmail: {
        title: 'Fracaso',
        description: 'Introduzca un correo electrónico válido',
      },
      failedSendEmail: {
        title: 'Fracaso',
        description: 'El envío de la prueba falló',
      },
      deleteItem: {
        title: 'Aviso',
        description:
          'Usted está prestes a eliminar este item, seguro(a) que quiere continuar?',
      },
      titleClosingMessage: 'Layout de cierre',
      titleAutomaticAnswer: 'Plantilla automática',
      enableSMS: 'Habilitar respuesta via SMS?',
      smsMessage:
        'En una escala de 0 a 10, cuál nota le atribuye a nuestra empresa?',
      feedbackInformQuestionSMS:
        'Por favor, informe la pregunta que será enviada por sms.',
      feedbackEnterQuestion:
        'Por favor, informe una pregunta o elimine este campo.',
      numMaxQuestions:
        'Usted alcanzó el número máximo de preguntas adicionales.',
      feedbackEnterOneQuestion: 'Por favor, informe una pregunta.',
      clickHere: 'Haga click aqui para accesar.',
      metrics: 'Métricas',
      review: 'Review',
      csat0a10: 'Escala 0 a 10',
      likert1a5: 'Likert - 1 a 5',
      likeDislike: 'Like/Dislike',
      emotion: 'Emotion',
      csat: 'Escala de 0 a 10',
      likert: 'Likert',
      multipleChoices: 'Opción multiple',
      text: 'Texto',
      registrationData: 'Datos de registro',
      label: 'Rótulo',
      multipleChoiceModal: {
        other: 'Otros',
        enableOther: 'Habilitar la opción "Otro" (Campo abierto)',
        title: 'Opción de respuesta múltiple',
        descripción:
          'Complete el tipo de respuesta de opción única o múltiple y las opciones de respuesta.',
        newOption: 'Opción {opción}',
        singleChoice: 'Elección única',
        multipleChoice: 'Opción múltiple',
      },
      allAnswersRequired: 'Respuesta obligatoria',
      customMandatoryQuestions: 'Respostas obrigatórias por pergunta adicional',
      widget: {
        type: 'Tipo de widget',
        allowedDomain: 'Dominio que usará el widget',
        scriptLabel: 'Script que se insertará en su plataforma',
        name: 'Nombre',
        phone: 'Teléfono',
        indicators: 'Indicadores',
        copy: 'Copiar',
        simulate: 'Simular',
        copiedTitle: 'Script copiado',
        copiedDescription: '¡El script se ha copiado en el portapapeles!',
        comment:
          'Solo los campos "name", "email", "phone" e "indicators" se pueden cambiar en el código anterior. Son los encargados de identificar al cliente. ',
        disabled: 'Pausar widget',
        paused: 'Widget pausado!',
      },
      questionFormatting: 'Visualización de preguntas (formato)',
      default: 'Padrão',
      custom: 'Personalizado',
      defaultDescription:
        'Alinea y centra preguntas adicionales en el medio de la página. Ver vista previa.',
      customDescription:
        'Alinee las preguntas adicionales a la derecha de la página. Ver vista previa.',
      typeQuestionLikert: 'Tipo de pregunta likert:',
      satisfied: 'Satisfecho',
      agreement: 'Acuerdo',
      frequency: 'Frecuencia',
      importance: 'importancia',
      probability: 'probabilidad',
      viewLikertSelected: 'Vista previa de la pregunta Likert seleccionada',
    },
    stepTwo: {
      labels: {
        amount: 'Cantidad',
        schedule: 'Horário',
        intervalDays: 'Intervalo en dias',
        type: 'Tipo',
        periodDays: ' Período en dias',
        expirationDays: 'Vencimiento en dias',
        titleAlert: 'Título del Alerta',
        ruleName: 'Nombre de la Regla',
        creationDate: 'Fecha de creación',
        actions: 'Acciones',
      },
      enableSMS: 'Habilitar recordatorio de SMS?',
      msgReminder:
        'Cuando está habilitado, todos los recordatorios también se enviarán por SMS. Debes tener saldo de SMS disponible!',
      msgReminderEmailSms:
        'Cuando está habilitado, todos los recordatorios se enviarán por correo electrónico y SMS. Se requiere saldo de SMS',
      typeMesssage: 'Escriba el mensaje para el enlace de recordatorio',
      mandatory: 'Obligatorio',
      titleSetting: 'CONFIGURACIÓN DE ALERTAS Y TRATATIVAS',
      titleQuarantineSetting: 'CONFIGURACIÓN DE CUARENTENA',
      titleExpirationDate: 'FECHA DE VENCIMIENTO',
      titleModelAlert: 'MODELO DE ALERTAS',
      selectedRule: 'Regla Seleccionada',
      noRule: 'Ninguna',
      noOption: 'Nada',
      newRule: 'Nueva regla',
      shoot: 'Envío',
      answer: 'Respuesta',
      actionGroup: 'Grupo de acción',
      reminderSetting: 'CONFIGURACIÓN DE RECORDATÓRIOS',
      feedbackEnterAlertName: 'Por favor, informe el nombre del alerta.',
      infoAlert: 'La alerta se recibirá en el idioma contestado por el cliente',
      feedbackNewAlert: 'Usted recibió un nuevo alerta!',
      feedbackIncorrectProduct:
        'No recibí el producto correcto y estoy muy molesto!',
      note: 'Nota',
      action: 'Acción',
      channel: 'Canal',
      phone: 'Teléfono',
      email: 'E-mail',
      feedbackUserReport: 'El usuario abajo reportó el seguiente feedback',
      message: 'Mensaje',
      emailJoao: 'joao@gmail.com',
      phoneUser: '(19)99854-1365',
      languageEmail: 'Idioma del correo electrónico',
    },
    stepThree: {
      actionPaused: '¡No se puede enviar porque la acción está en pausa!',
      labels: {
        addIndicators: 'Adicionar indicadores',
        personName: 'Nombre',
        personEmail: 'E-mail',
        personPhone: 'Teléfono',
      },
      titleIndicators: 'Indicadores',
      titleLayout: 'LAYOUT DEL ARCHIVO',
      titleClearTable: 'Limpiar tabla de clientes',
      titleImportData: 'IMPORTAR DATOS',
      titleInsertCustomer: 'Incluir cliente',
      titleScheduling: 'AGENDAMIENTO',
      titleAddIndicator: 'Incluir Indicador',
      shootNow: 'Enviar ahora',
      scheduleShooting: 'Agendar envío',
      shoot: 'Enviar',
      toSchedule: 'Para programar',
      settingsSaved: 'Configuraciones de la Acción Guardadas!',
      skipImport: 'Avanzar Para Importación',
      wish: 'Qué desea hacer ahora?',
      continueAfter: 'Continuar Después',
      cancel: 'Cancelar',
      importCustomersXLS: 'Importar clientes via archivo XLS',
      informFieldName: 'Informe el campo {nameField}',
      informFieldEmail: 'Informe el campo {emailField}',
      informFieldPhone: 'Informe el campo {emailPhone}',
      failedAddCustomer: 'Falla al incluir cliente.',
      importFile: 'Importar archivo',
      dragFile: 'Haga click aqui o arrastre el archivo hasta aqui',
      dropFile: 'Suelte el archivo aqui...',
      insertCustomers: 'Incluir clientes manualmente',
      enterIndicatorsName: 'Digite el nombre del indicador',
      itens: 'Items',
      buttonAddColumn: 'Adicionar',
      downloadModelButton: 'Descargar modelo',
      addedIndicators: 'Indicadores adicionados',
      indicator: 'Indicador',
      remove: 'Eliminar',
      generateQrCode: 'Generación del Código Qr',
      uniqueQrCode: 'Código QR único',
      uniqueQrCodeDescription:
        'Con el código generado, su cliente podrá escanear a través de la cámara del teléfono celular y ser dirigido a la página de la encuesta. Este modelo es ideal para casos de investigación más simples, donde no es necesario identificar un producto o servicio en particular.',
      multipleQrCode: 'Código QR múltiple',
      multipleQrCodeDescription:
        'Con el código generado, su cliente podrá escanear a través de la cámara del teléfono celular y ser dirigido a la página de la encuesta. Este modelo es ideal para casos de investigación donde existe la necesidad de generar varios códigos QR para la misma acción y donde existe la necesidad de identificar un producto, servicio o unidad en particular con códigos diferentes.',
      downloadQrCode: 'Descargar código QR',
      importValueQrCode: 'Importar valor a través de un archivo XLS',
      enterValueManually: 'Ingrese el valor manualmente',
      generateQrCodeButton: 'Generar código QR',
      viewQrCodes: 'Ver códigos QR generados',
      generatedQRCodes: 'Códigos QR generados',
      descriptionGeneratedQrCodes:
        'A continuación se muestra la lista de todos los códigos generados que se pueden utilizar para su búsqueda.',
      savedQrCodes: 'Códigos QR guardados!',
      backListActions: 'Volver al listado de acciones',
      invalidIdField:
        'No es posible incluir un campo con la identificación del nombre para el Código QR.',
      deleteQrcode: 'Eliminar código QR',
      deleteQrcodeDescription:
        '¿Está seguro de que desea eliminar el código QR? Ya no será posible responder encuestas a través de este enlace. ',
      qrcodeTableOptions: 'Opciones',
      indicatorHeaders: {
        filial: {
          header: 'Sucursal',
          content:
            'Nombre de Tiendas, sucursales, unidades. Este indicador puede ser utilizado para jerarquía de usuarios atribuyendo permisos para determinadas sucursales.',
        },
        ih2: {
          header: 'IH2',
          content:
            'Indicador de jerarquía 2 (IH2) puede ser utilizado para departamentos, grupos, etc, siendo que su principal función es atribuir permisos por usuario.',
        },
        report: {
          header: 'Reporte',
          content:
            'Indicadores tipo informe son indicadores que serán utilizados para análisis detallados en reportes, creando divisiones en los reportes de acuerdo con los datos de este indicador.',
        },
        map: {
          header: 'Mapa',
          content:
            'Tipo Mapa debe ser rellenado con datos de departamentos(o ciudades, o provincias) con dos letras, este indicador llenará un mapa de colores de acuerdo con la nota principal y departamento(o ciudades, o provincias).',
        },
        date: {
          header: 'Fecha',
          content:
            'Indicador tipo Fecha debe ser seleccionado en este tipo para que quede con el formato correcto dd/mm/aaaa',
        },
        auxiliary: {
          header: 'Auxiliar',
          content:
            'Indicadores para visualización en detalles pero sin quiebra por reporte, ej: número factura, identificación del cliente, código cliente, fechas, etc. son indicadores que no utilizaremos para visón de reportes.',
        },
        clientId: {
          header: 'Client ID',
          content: 'Unique customer identification key.',
        },
        expiration: {
          header: 'Fecha Expiração',
          content:
            'Indicador tipo Fecha de Espiración debe ser rellenado con el formato dd/mm/aaaa',
        },
      },
      messages: {
        warning: {
          title: '¡Atención!',
          description:
            'La activación se realizó solo a través de {channel1}. No tienes suficiente saldo para disparar a través de {channel2}. Póngase en contacto con el equipo de IndeCX CS para obtener más información.',
        },
        exceeded: {
          title: 'Saldo insuficiente!',
          description:
            'Saldo insuficiente para envío! Usted está intentando enviar {totalInvites} invitaciones y tiene {balanceMsg} de saldo. Favor contactar el equipo de CS de IndeCX para mayores informaciones.',
        },
        shots: {
          title: 'Envío Configurado!',
          description:
            'Usted será redireccionado para su lista de acciones para acompañar el status del envío.',
        },
        dangerMode: {
          title: 'Oops... Algo salió mal!',
          description:
            'Hubo un problema al adicionar este tipo para el indicador.',
        },
        removeColumn: {
          title: 'Desactivar indicador',
          description: 'Seguro(a) de que desea desactivar este indicador?',
        },
        errorMessage: {
          title: 'Error al incluir cliente',
          description: 'Hubo un error al procesar su solicitud.',
        },
        success: {
          title: 'Éxito!',
          description: 'El indicador fue desactivado!',
        },
        deleteList: {
          title: 'Eliminar Lista',
          description: 'Seguro(a) que desea eliminar esta lista de clientes?',
        },
        emailInvalid: {
          title: 'Email inválido',
          description: 'Por favor, ingrese un email válido.',
        },
        addClientSuccess: {
          title: 'Éxito',
          description: 'Cliente agregado exitosamente!',
        },
        errors: {
          invalidColumn:
            'No es posible tener dos columnas con el mismo nombre.',
          invalidNumber: 'Por favor, incluya un número válido para el cliente.',
          invalidCharacters: 'Caracteres . y $ no son permitidos en el nombre',
        },
      },
    },
  },
  actionGroup: {
    pageTitle: 'Grupo de acciones',
    searchInput: 'Haga una busqueda...',
    searchButton: 'Limpiar',
    groupTable: {
      labels: {
        id: 'ID',
        name: 'Nombre',
        metric: 'Métrica',
        favourite: 'Favorito',
        actions: 'Acciones associadas',
        options: 'Opciones',
      },
    },
    newGroupButton: 'Nuevo grupo',
    editGroup: 'Editar grupo',
    newGroup: 'Nuevo grupo',
    save: 'Guardar',
    groupName: 'Nombre del Grupo',
    placeholderGroupName: 'Digite el nombre del grupo',
    metric: 'Métrica',
    favoriteGroup: 'Grupo Favorito',
    nps010: 'NPS 0 a 10',
    nps15: 'NPS 1 a 5',
    ces15: 'CES 1 a 5',
    csat15: 'CSAT 1 a 5 (Top 2 box)',
    csatAverage15: 'CSAT(promedio) 1 a 5',
    csat0to10Average: 'CSAT 0 a 10(Promedio)',
    fiveStars: '5-Stars',
    messages: {
      saveError: {
        title: 'Oops...',
        description: 'Por favor, incluir un nombre para el grupo.',
      },
      edited: {
        title: 'Grupo editado!',
        description: 'Grupo editado con éxito!',
      },
      created: {
        title: 'Grupo registrado!',
        description: 'Nuevo grupo registrado con éxito!',
      },
      favorite: {
        title: 'Seguro(a)?',
        description1: 'Desea desfavoritar el grupo',
        description2: 'Desea favoritar el grupo',
      },
      favoriteOk: {
        title1: 'Grupo desfavorecido!',
        title2: 'Grupo favorecido!',
        description1: 'Grupo no es mas su favorito.',
        description2: 'Grupo se convirtió en su favorito.',
      },
      deleted: {
        title: 'Seguro(a)?',
        description: 'Desea eliminar el grupo',
      },
      deletedOk: {
        title: 'Grupo eliminado!',
        description: 'El grupo fue eliminado.',
      },
    },
  },
  answers: {
    pageTitle: 'Respuestas',
    searchInput: 'Haga una busqueda...',
    searchButton: 'Limpiar',
    email: 'E-mail',
    telephone: 'Teléfono',
    channel: 'Canal',
    action: 'Acción',
    metric: 'Métrica',
    exportCsv: 'Exportar a CSV',
    exportXls: 'Exportar a XLSX',
    csvCommaSeparator: 'Separar por coma',
    csvPipeSeparator: 'Separar por tubería',
    analyticsDownload: 'Análisis de BI',
    categoriesDownload: 'Categorías',
    answersDownload: 'Respuestas',
    feedbackEdited: 'Comentario editado por {feedbackEditedAutor}',
    editComment: 'Editar Comentario',
    editComentary:
      'Usted puede editar el comentario del cliente para adicionar alguna consideración al texto.',
    nobody: 'Nadie',
    addQuestions: 'Preguntas Adicionales',
    details: 'Detalles',
    removeAnswer: 'Eliminar Respuesta',
    cancel: 'Cancelar',
    remove: 'Eliminar',
    removeSuccess: 'Respuesta eliminada con éxito!',
    ops: 'Oops...',
    categorization: 'Categorización',
    categorizationAdditional: 'Categorización Input',
    foundAnswer: 'respuesta encontrada',
    infoAnswer: 'Información',
    gradeAnswer: 'Nota',
    ratingAnswer: 'Evaluación',
    nameAnswer: 'Nombre',
    emailAnswer: 'Correo electrónico',
    phoneAnswer: 'Teléfono',
    channelAnswer: 'Canal',
    actionAnswer: 'Acción',
    metricAnswer: 'Métrica',
    feedbackAnswer: 'Comentarios',
    categoryAnswer: 'Categoria',
    nextAnswer: 'Siguiente respuesta',
    previousAnswer: 'Respuesta anterior',
    noAnswersFound: 'No se encontraron respuestas.',
    donwload: {
      title: 'Éxito!',
      description:
        'El archivo está siendo preparado! usted puede acompañar el status de procesamiento en el menu "Downloads".',
    },
    deleteAnswer: {
      title: 'Eliminar Respuesta',
      description:
        'Seguro(a) que desea eliminar esa respuesta? Esto puede afectar directamente el cálculo de su NPS.',
    },
    deleteCategory: {
      title: 'Remover Categoría',
      description: 'Seguro(a) que desea eliminar esa categoría?',
    },
    categoryDelSuccess: 'Categoría eliminada com éxito!',
    profileSelect: {
      select: 'Filtro por perfil',
      all: 'Todos',
      detractors: 'Detractores',
      neutral: 'Neutros',
      promoters: 'Promotores',
    },
    channelSelect: {
      select: 'Filtro por canal',
      all: 'Todos',
      email: 'Email',
      sms: 'SMS',
      link: 'Link',
      qrcode: 'QR-Code',
      manual: 'Manual',
      whatsapp: 'Whatsapp',
      treatmentTags: 'Etiquetas de tratamiento',
    },
    categorySelect: {
      select: 'Filtro por categoria',
      all: 'Todas',
      empty: 'Sin categoría (vacio)',
    },
    responsibleSelect: 'Seleccione el responsable',
    treatmentSelect: 'Seleccione',
    filterOptions: {
      select: 'Seleccionar el filtro',
      profile: 'Perfil',
      status: 'Status',
      category: 'Categoría',
      responsible: 'Responsable',
      notification: 'Notificación',
      audio: 'Audio',
      channel: 'Canal',
      comments: 'Comentario',
      anonymous: 'Anônimo',
      treatmentTags: 'Etiquetas de tratamiento',
      addQuestion: 'Pregunta adicional',
      sentiment: 'Sentimiento',
      partial: 'Respuesta parcial',
      recordedAudio: 'Audio grabado',
    },
    sentiment: {
      positive: 'Positivo',
      negative: 'Negativo',
      neutral: 'Neutro',
    },
    notificationSelects: {
      viewed: 'Visto',
      noViewed: 'No visto',
    },
    commentsSelect: {
      select: 'Filtro por comentario',
      all: 'Todas',
      withComments: 'Apenas con comentario',
      noComments: 'apenas sin comentario',
    },
    anonymousSelect: {
      select: 'Seleccione un filtro',
      all: 'Todas',
      anonymous: 'Anónimo',
      yes: 'Si',
      no: 'No',
    },
    recordedAudio: {
      select: 'Seleccione un filtro',
      all: 'Todas',
      anonymous: 'Anónimo',
      yes: 'Si',
      no: 'No',
    },
    justCommentsLable: 'Apenas con comentario',
    answerTable: {
      labels: {
        id: 'Id',
        date: 'Fecha',
        grade: 'Nota',
        client: 'Cliente',
        comment: 'Comentario',
        category: 'Categorias',
        options: 'Opciones',
        tags: 'Tags',
      },
    },
    answersDetails: {
      details: 'Detalles',
      historic: 'Histórico de',
      note: 'Nota',
      channel: 'Canal',
      action: 'Acción',
      comment: 'Comentario',
      search: 'Haz tu busqueda...',
      transferSuccess: 'Transferencia exitosa',
      transferError: 'Error de transferencia',
      sentimentAnalyze: 'Análisis de Sentimiento',
      branchSearchDescription:
        'Puede transferir una encuesta entre sucursales si es necesario. Seleccione a continuación a qué sucursal desea transferir esta búsqueda.',
      transferFactoryAccount: 'Transferencia a cuenta de fábrica',
      transferAffiliateSearch: 'Transferir búsqueda de afiliados',
      transferBetweenShares: 'Transferir la investigación entre acciones',
      sentimentMsg:
        'A IndeCX utiliza Inteligência Artificial para classificação do sentimento e extração de palavras-chaves com base nos comentários. O score abaixo indica o nível do sentimento, podendo variar de -100 até 100.',
      sentiment: 'Sentimiento',
      positive: 'Positivo',
      neutral: 'Neutro',
      negative: 'Negativo',
      keywords: 'Keywords',
      email: 'E-mail',
      phone: 'Teléfono',
      date: 'Fecha',
      categories: 'Categorias',
      indicators: 'Indicadores',
      none: 'Nada',
      additionalQuestions: 'Preguntas adicionales',
      treatments: {
        status: 'Status',
        responsible: 'Responsable',
        changeStatus: 'Cambiar Status',
        selectOpenStatus: 'Abierto',
        selectAnalisysStatus: 'En análisis',
        selectEscalatedStatus: 'Escalonado',
        selectAnsweredStatus: 'Respondido',
        changeResponsible: 'Alterar Responsable',
        veryUnsatisfied: 'Muy insatisfecho',
        dissatisfied: 'Insatisfecho',
        indifferent: 'Indiferente',
        satisfied: 'Satisfecho',
        verySatisfied: 'Muy Satisfecho',
        anonymous: 'Anónimo',
        noName: 'Sin Nombre',
        back: 'Volver',
        updateTemplate: 'Actualizar plantilla',
        deleteTemplate: 'Borrar plantilla',
        feed: 'Feed',
        addCommentary: 'Agregar comentario',
        nobody: 'Nadie',
        dataAction: 'Datos de la acción',
        treatment: 'Tratativas',
        treatmentTabLabel: 'TRATATIVAS',
        answerTabLabel: 'CONTESTAR',
        selectFilterTreatments: 'Seleccione el filtro',
        systemAlert: 'Alerta del sistema',
        commentFilterTreatments: 'Comentario',
        statusFilterTreatments: 'Estado',
        responsibleFilterTretaments: 'Responsable',
        allFilterTreatments: 'Todos',
        mostRecent: 'Más reciente',
        mostOld: 'Más antiguo',
        to: 'Para',
        subject: 'Tema',
        from: 'Remitente',
        template: 'Plantilla',
        send: 'Enviar',
        swAdd: {
          title: 'Comentario Adicionado!',
          description: 'Su comentario fue adicionado a esta tratativa',
        },
        swAddError: {
          title: 'Oops! Algo salió mal!',
          description: 'Intente nuevamente más tarde!',
        },
        swSave: {
          title: 'Éxito!',
          description:
            'Las infomaciones adicionales fueron guardadas con éxito!',
        },
        swResponsible: {
          title: 'Responsable Modificado!',
          description: 'Un nuevo responsable fue marcado para esta tratativa.',
        },
        swStatus: {
          title: 'Status Modificado!',
          description: 'El status de esa tratativa fue modificado para',
        },
        swExceededQuantity: {
          title: '¡Límite de archivos alcanzado!',
          description: 'Se ha alcanzado la cantidad máxima de 5 archivos.',
        },
        enterContact: 'Se comunicó con el cliente',
        yes: 'Sí',
        no: 'No',
        whatChannel: '¿Por qué canal se realizó el contacto?',
        wpp: 'Whatsapp',
        phone: 'Teléfono',
        email: 'Correo electrónico',
        personally: 'Personalmente',
        others: 'Otros',
        caseDifficult:
          'Si tuvo dificultades con las partes de este servicio, por favor informe:',
        saveInfo: 'Guardar información',
        pieceNumber: 'Número de pieza',
        pieceName: 'Nome da pieza',
        price: 'Precio',
      },
    },
    filterTypeOptions: {
      email: 'Email',
      id: 'ControlID',
      name: 'Nombre',
      phone: 'Teléfono',
      feedback: 'Comentario',
      clientId: 'ClientID',
    },
    entirePeriodWarning: {
      title: '¡Aviso!',
      description: 'Introduzca un período más corto.',
    },
  },
  manualAnswer: {
    pageTitle: 'Encuesta manual',
    searchInput: 'Haga una busqueda...',
    searchButton: 'Limpiar',
    invitesTable: {
      labels: {
        id: 'ID',
        action: 'Acción',
        client: 'Cliente',
        submit: 'Envío',
        reminder: 'Recordatório',
        days: 'Dias',
        channel: 'Canal',
        status: 'Status',
        manual: 'Respuesta manual',
      },
    },
    metric: 'Métrica',
    nps010: 'NPS 0 a 10',
    nps15: 'NPS 1 a 5',
    ces15: 'CES 1 a 5',
    csat15: 'CSAT 1 a 5 (Top 2 box)',
    csatAverage15: 'CSAT(Promedio) 1 a 5',
    csat0to10Average: 'CSAT 0 a 10 (Promedio)',
    likeDislike: 'Like/Dislike - 0 e 1',
    fiveStars: '5-Stars',
    noName: 'Sin Nombre',
    email: 'E-mail',
    phone: 'Teléfono',
    both: 'ambos',
    active: 'Activo',
    expired: 'Vencido',
    updateInvite: 'Actualizar invitación',
    noInvite: 'Invitación no disponible.',
    messages: {
      refresh: {
        title: 'Reactivar Invitación',
        description: 'Seguro(a) que desea reactivar la invitación del cliente?',
        okLabel: 'Reactivar',
        cancelLabel: 'Cancelar',
      },
      answeredSearch: {
        title: 'Encuesta Respondida',
        description: 'La encuesta fue respondida manualmente para el cliente.',
      },
      unansweredSurvey: {
        title: 'Encuesta no respondida',
        description: 'Por favor, ingrese una nota de 0 a 10.',
      },
      required: 'Por favor, responda todas as perguntas obrigatórias.',
    },
  },
  sentiment: {
    pageTitle: 'Análisis de Sentimiento',
    sentimentSelect: {
      select: 'Filtro por sentimiento',
      all: 'Todos',
      positive: 'Positivo',
      neutral: 'Neutro',
      negative: 'Negativo',
    },
    table: {
      sentiment: 'Reacción',
      score: 'Sentimiento',
      keywords: 'Palabras Clave',
      positive: 'Positivo',
      neutral: 'Neutro',
      negative: 'Negativo',
      options: 'Visualizar',
    },
  },
  clients: {
    pageTitle: 'Clientes',
    searchInput: 'Haga una busqueda...',
    searchButton: 'Limpiar',
    exportCsv: 'Exportar a CSV',
    exportXls: 'Exportar a XLS',
    csvCommaSeparator: 'Separar por coma',
    csvPipeSeparator: 'Separar por tubería',
    messages: {
      export: {
        title: 'Éxito!',
        description:
          'El archivo está siendo preparado! Usted puede acompañar el status de procesamiento en el menu "Downloads".',
      },
      error: {
        title: 'Oops...',
      },
      entirePeriodWarning: {
        title: '¡Aviso!',
        description: 'Introduzca un período más corto.',
      },
    },
    clientsTable: {
      labels: {
        id: 'ID',
        name: 'Nombre',
        email: 'E-mail',
        phone: 'Teléfono',
        lastAction: 'Acción',
        lastImportation: 'Importación',
        lastInvite: 'Última invitación',
        lastAnswer: 'Última respuesta',
        status: 'Status',
        answered: 'Contestado',
        lastReminder: 'Último Recordatório',
        reminders: 'Recordatórios',
        editReminder: 'Para editar',
      },
      searchOptions: {
        email: 'Email',
        id: 'ControlID',
        name: 'Nombre',
        phone: 'Teléfono',
        clientId: 'ClientID',
      },
      answeredYes: 'Si',
      answeredNo: 'No',
      statusYes: 'Activo',
      statusNo: 'Inactivo',
    },
  },
  quarentines: {
    pageTitle: 'Cuarentena',
    searchInput: 'Haga una busqueda...',
    searchButton: 'Limpiar',
    totalQuarentine: 'Total de clientes en cuarentena',
    exportCsv: 'Exportar a CSV',
    exportXls: 'Exportar a XLS',
    csvCommaSeparator: 'Separar por coma',
    csvPipeSeparator: 'Separar por tubería',
    messages: {
      export: {
        title: 'Éxito!',
        description:
          'El archivo está siendo preparado! Usted puede acompañar el status de procesamiento en el menu "Downloads".',
      },
      error: {
        title: 'Oops! Algo salió mal!',
        description: 'Intente nuevamente más tarde!',
      },
      removeOk: {
        title: 'Éxito!',
        description: 'Cuarentena eliminada com éxito',
      },
      removeQuarentine: {
        title: 'Eliminar Cuarentena',
        description: 'Seguro(a) que desea eliminar la cuarentena?',
        ok: 'Cuarentena eliminada com éxito',
      },
    },
    action: 'Acción',
    company: 'Empresa',
    quarentinesTable: {
      labels: {
        email: 'E-mail',
        phone: 'Teléfono',
        clientId: 'ClientId',
        type: 'Tipo',
        action: 'Acción',
        quarentineDate: 'Fecha Cuarentena',
        expireDate: 'Vence en',
        actions: 'Acciones',
      },
    },
  },
  blacklist: {
    totalBlacklist: 'Total de clientes incluidos en la lista negra',
    addClient: 'añadir cliente',
    pageTitle: 'Blocklist',
    searchInput: 'Haga una busqueda...',
    searchButton: 'Limpiar',
    labelsTable: {
      email: 'E-mail',
      phone: 'Teléfono',
      controlId: 'ControlId',
      action: 'Acción',
      reason: 'Razón',
      blackListDate: 'Fecha de lista negra',
      actions: 'Acciones',
      channel: 'Canal',
    },
    exportCsv: 'Exportar a CSV',
    exportXls: 'Exportar a XLS',
    csvCommaSeparator: 'Separar por coma',
    csvPipeSeparator: 'Separar por tubería',
    messages: {
      export: {
        title: 'Éxito!',
        description:
          'El archivo está siendo preparado! Usted puede acompañar el status de procesamiento en el menu "Downloads".',
      },
      error: {
        title: 'Oops! Algo salió mal!',
        description: 'Intente nuevamente más tarde!',
      },
      removeOk: {
        title: 'Éxito!',
        description: 'Blocklist eliminada com éxito',
      },
      removeBlackList: {
        title: 'Eliminar blocklist',
        description: 'Seguro(a) que desea eliminar la Blocklist?',
        ok: 'Blocklist eliminada com éxito',
      },
    },
  },
  downloads: {
    pageTitle: 'Mis downloads',
    clients: 'Clientes',
    answers: 'Respuestas',
    invites: 'Invitaciones',
    invitesStatus: 'Status Invitaciones',
    answerIndicators: 'Respuestas (Indicador)',
    reminders: 'Recordatórios',
    scheduling: 'Agendamientos',
    trash: 'Papelera',
    answerDetails: 'Detalles de la acción',
    quarentine: 'Cuarentena',
    blackList: 'BlockList',
    analytics: 'Análisis de BI',
    category: 'Categorías',
    consumption: 'Consumo',
    action: 'Acciones',
    downloading: 'downloading',
    internalError: 'Error interno.',
    fileNotFound: 'Archivo no encontrado.',
    errorTitle: 'Oops...',
    finished: 'concluido',
    downloadsTable: {
      labels: {
        id: 'ID',
        date: 'Fecha',
        type: 'Tipo',
        extension: 'Extensión',
        status: 'Status',
        file: 'Archivo',
      },
    },
    invalidDownload: {
      title: 'Archivo no disponible!',
      description:
        'El archivo ya no existe. Genera otra descarga e inténtalo de nuevo.',
    },
  },
  uploads: {
    pageTitle: 'Mis uploads',
    errorTitle: 'Oops...',
    fillFields: 'Favor preencher todos los campos',
    sendFile: 'Enviar Archivo',
    modalTitle: 'Enviar Archivo',
    branchLabel: 'Seleccione Filial',
    referenceLabel: 'Referéncia do Archivo',
    actionLabel: 'Seleccione la Acción',
    fileLabel: 'Seleccione o Archivo',
    attachFile: 'Adjuntar archivo',
    indicatorsError: 'Formato de archivo incorrecto',
    notificationTitle: 'Importante',
    notificationText: `El sistema de carga solamente acepta archivos con el mismo layout
      de la acción seleccionada. Verifique si el archivo utilizado contiene la misma
      cantidad de columnas y si el orden de las mismas están de acuerdo con el
      configurado anteriormente de la acción`,
    selectReferenceLabel: 'Tipo',
    referenceSales: 'Ventas',
    referenceAftersales: 'Post-ventas',
    selectLabel: 'Seleccionar',
    selectPlaceholder: 'Seleccione un archivo o arrastre hasta aqui...',
    dropPlaceholder: 'Arrastre el archivo hasta aqui',
    uploadsTable: {
      labels: {
        id: 'ID',
        user: 'Usuário',
        date: 'Fecha',
        file: 'Archivo',
        branch: 'Filial',
        action: 'Acción',
        reference: 'Referéncia',
        options: 'Opciones',
        remove: 'Eliminar',
        download: 'Download',
      },
    },
    removeUpload: {
      title: 'Eliminar arqchivo',
      description: `Seguro(a) que desea eliminar este archivo?`,
      ok: 'Archivo eliminado con éxito',
    },
  },
  resend: {
    pageTitle: 'Reenviar encuesta (invitaciones ativas)',
    pageTitlewpp: 'Envio manual de encuesta por Whatsapp',
    searchInput: 'Haga una busqueda...',
    searchButton: 'Limpiar',
    selectPage: 'Seleccionar página',
    selectsInfo: {
      clientsLength: 'Fueron seleccionados {length} clientes para reenvio.',
      selectAll: 'Seleccionar todos los {length} clientes.',
      allClients: 'Todos los {length} fueron seleccionados.',
      cleanSelection: 'Limpiar selección.',
    },
    invitesTable: {
      labels: {
        id: 'ID',
        action: 'Acción',
        client: 'Cliente',
        submit: 'Envío',
        resend: 'Último reenvio',
        reminder: 'Recordatório',
        days: 'Dias',
        channel: 'Canal',
        link: 'Link',
        select: 'Seleccionar',
        message: 'Mensaje',
        copy: 'Copiar',
        lastSend: 'Último envio',
      },
    },
    cancelInvitesButton: 'Cancelar invitaciones',
    resendButton: 'Reenviar',
    metric: 'Métrica',
    nps010: 'NPS 0 a 10',
    nps15: 'NPS 1 a 5',
    noName: 'Sin Nombre',
    email: 'E-mail',
    phone: 'Teléfono',
    both: 'ambos',
    copyLink: 'Copiar Link',
    exportCsv: 'Exportar para CSV',
    exportXls: 'Exportar para XLS',
    sendWpp: 'Reenviar via WhatsApp',
    whatsappWebMsg: 'Enviar link de encuesta automatizada via WhatsApp',
    send: 'Enviar',
    name: 'Nombre',
    messages: {
      copyUrl: {
        title: 'Link Copiado',
        description:
          'El link del cliente fue copiado para el area de transferencia.',
      },
      copyMsg: {
        title: 'Mensaje Copiada',
        description: 'La mensaje fue copiada para el area de transferencia.',
      },
      sendNoClient: {
        title: 'Ningún Cliente Seleccionado',
        description:
          'Usted debe seleccionar al menos un cliente para reenviar la encuesta.',
      },
      sendAllInvites: {
        title: 'Reenviar Encuesta',
        description:
          'Seguro(a) que desea reenviar la encuesta para todos los clientes seleccionados?',
        yesLabel: 'Sí',
        noLabel: 'No',
        sentMsg1: 'La encuesta fue reenviada con éxito para',
        sentMsg2: 'cliente(s) de',
        sentMsg3: 'seleccionado(s)!',
        sentMsgOk:
          'La encuesta fue reenviada con éxito para el(los) cliente(s) seleccionado(s)!',
      },
      sendInvites: {
        title: 'Reenviar Encuesta',
        description1: 'Seguro(a) que desea reenviar la encuesta para',
        description2: 'cliente(s)',
        yesLabel: 'Sí',
        noLabel: 'No',
        sentMsg1: 'La encuesta fue reenviada con éxito para',
        sentMsg2: 'cliente(s) de',
        sentMsg3: 'seleccionado(s)!',
        sentMsgOk:
          'La encuesta fue reenviada con éxito para el(los) cliente(s) seleccionado(s)!',
      },
      warning: {
        title: '¡Atención!',
        description:
          'La activación se realizó solo a través de {channel1}. No tienes saldo para disparar a través de {channel2}. Póngase en contacto con el equipo de IndeCX CS para obtener más información.',
      },
      noQuota: {
        title: 'Saldo insuficiente!',
        description1:
          'Saldo insuficiente para envío! usted está intentando enviar',
        description2: 'invitaciones y tiene',
        description3:
          'de saldo. Por favor contactar el equipo de CS de IndeCX para mayores informaciones',
        description:
          'Saldo insuficiente para activar! Está intentando activar {totalInvites} invitaciones y tiene {balanceMsg} de saldo. Póngase en contacto con el equipo de IndeCX CS para obtener más información.',
      },
      quotaError: {
        title: 'Saldo insuficiente!',
        description:
          'No tienes suficiente saldo para disparar a través de {channel}. Póngase en contacto con el equipo de IndeCX CS para obtener más información.',
      },
      cancelNoClient: {
        title: 'Ningún Cliente Seleccionado',
        description:
          'Usted debe seleccionar al menos una invitación para cancelar.',
      },
      cancelAllInvites: {
        title: 'Cancelar invitaciones',
        description:
          'Seguro(a) que desea cancelar las invitaciones para todos los clientes seleccionados?',
        yesLabel: 'Sí',
        noLabel: 'No',
        cancelMsgOk:
          'Las invitaciones fueron canceladas con éxito para los clientes seleccionados!',
      },
      cancelInvites: {
        title: 'Cancelar invitaciones',
        description1: 'Seguro(a) que desea cancelar las invitaciones para',
        description2: 'cliente(s)?',
        yesLabel: 'Sí',
        noLabel: 'No',
        cancelMsgOk:
          'Las invitaciones fueron canceladas con éxito para los clientes seleccionados!',
      },
      export: {
        title: 'Éxito!',
        description:
          'El archivo está siendo preparado! Usted puede acompañar el status de procesamiento en el menu "Downloads".',
        errorTitle: 'Oops...',
      },
    },
  },
  reminders: {
    pageTitle: 'Recordatório',
    searchInput: 'Haga una busqueda...',
    searchButton: 'Limpiar',
    selectPage: 'Seleccionar página',
    channelFilter: {
      select: 'Todos los canales',
      email: 'E-mail',
      sms: 'SMS',
      all: 'E-mail y SMS',
    },
    selectInfo: {
      remindersLength:
        'Usted seleccionó {length} recordatório(s) para cancelar.',
      selectAll: 'Seleccionar todos los {length}.',
      allReminders:
        'Usted seleccionó todos los {length} recordatório(s) para cancelar.',
      cleanSelection: 'Limpiar selección.',
    },
    remindersTable: {
      labels: {
        id: 'ID',
        action: 'Acción',
        client: 'Cliente',
        date: 'Fecha del recordatório',
        channel: 'Canal',
        cancel: 'Cancelar recordatórios',
      },
    },
    cancelRemindersButton: 'Cancelar recordatórios',
    updateList: 'Actualizar Lista',
    messages: {
      sendNoReminder: {
        title: 'Oops...',
        description:
          'Usted debe seleccionar al menos un recordatório para eliminar.',
      },
      send: {
        title: 'Cancelar recordatórios',
        description:
          'Seguro(a) que desea cancelar los recordatórios seleccionados?',
      },
      sendError: {
        title: 'Error',
        description: 'Hubo algún error',
      },
      download: {
        title: 'Éxito!',
        description:
          'El archivo está siendo preparado! Usted puede acompañar el status de procesamiento en el menu "Downloads".',
      },
      downloadError: {
        title: 'Oops! Algo salió mal...',
      },
    },
  },
  scheduling: {
    pageTitle: 'Agendamientos',
    searchInput: 'Haga una busqueda...',
    searchButton: 'Limpiar',
    selectPage: 'Seleccionar página',
    channelFilter: {
      select: 'Todos los canales',
      email: 'E-mail',
      sms: 'SMS',
      all: 'E-mail y SMS',
    },
    selectInfo: {
      schedulingLength:
        'Usted seleccionó {length} agendamiento(s) para cancelar.',
      selectAll: 'Seleccionar todos los {length}.',
      allSchedulings:
        'Usted seleccionó todos los {length} agendamiento(s) para cancelar.',
      cleanSelection: 'Limpiar selección.',
    },
    schedulingTable: {
      labels: {
        id: 'ID',
        action: 'Acción',
        client: 'Cliente',
        date: 'Fecha del agendamiento',
        channel: 'Canal',
        cancel: 'Cancelar agendamientos',
      },
    },
    messages: {
      cancelNoSelect: {
        title: 'Oops...',
        description:
          'Usted debe seleccionar al menos un agendamiento para eliminar.',
      },
      cancelQuestion: {
        title: 'Cancelar agendamientos',
        description:
          'Seguro(a) que desea cancelar los agendamientos seleccionados?',
      },
      cancelError: {
        title: 'Error',
        description: 'Hubo algún error',
      },
      download: {
        title: 'Éxito!',
        description:
          'El archivo está siendo preparado! Usted puede acompañar el status de procesamiento en el menu "Downloads".',
      },
      maxDownloadError: {
        title: 'Límite de registros!',
        description:
          'Gran cantidad de registros para Download. Por favor, entre en contacto con el soporte IndeCX para esta operacion',
      },
      downloadError: {
        title: 'Oops! Algo salió mal...',
      },
    },
    cancelRemindersButton: 'Cancelar agendamientos',
  },
  trash: {
    actionsMenu: {
      title: 'Acciones',
      actionsTable: {
        labels: {
          action: 'Acciones',
          date: 'Fecha de eliminación',
          user: 'Usuario',
          restore: 'Restaurar',
        },
      },
    },
    answersMenu: {
      title: 'Respuestas',
      searchInput: 'Haga una busqueda...',
      searchButton: 'Limpiar',
      answersInfo: 'Informaciones de la respuesta',
      answersRestore: 'Restaurar respuesta',
      exportXLS: 'Exportar para XLS',
      swExport: {
        title: 'Éxito!',
        description:
          'El archivo está siendo preparado! Usted puede acompañar el status de procesamiento en el menu "Downloads".',
      },
      swError: {
        title: 'Oops',
      },
      swQuestion: {
        title: 'Seguro(a)?',
      },
      swAction: {
        description: 'Desea realmente restaurar esta acción?',
      },
      swAnswer: {
        description: 'Desea realmente restaurar esta respuesta?',
      },
      swRestore: {
        description: 'La acción fue restaurada',
      },
      answersTable: {
        labels: {
          action: 'Acción',
          id: 'ID de la encuesta',
          date: 'Fecha de eliminación',
          user: 'Usuario',
          client: 'Cliente',
          email: 'Correo electrónico',
          phone: 'Teléfono',
          feedback: 'Feedback',
          reason: 'Motivo de la eliminación',
          options: 'Opciones',
        },
      },
    },
  },
  treatments: {
    pageTitle: 'Tratativas individuales',
    pageSubTitle:
      'En este módulo puede manejar a cada cliente individualmente de forma dinámica.',
    filterRullers: 'Orden de trato basado en la regla:',
    scheduleClient: 'Cliente programado:',
    modifyComment: 'Modificar Comentario',
    registerCategory: 'Registre una categoria',
    here: 'aqui.',
    searchDropdown: 'Search',
    product: 'Producto',
    attendance: 'Atención',
    term: 'Plazo',
    delivery: 'Entrega',
    responseInformation: 'Informaciones de la respuesta de',
    close: 'Cerrar',
    note: 'Nota',
    channel: 'Canal',
    email: 'E-mail',
    phone: 'Teléfono',
    none: 'Nada',
    date: 'Fecha',
    comment: 'Comentario',
    additionalQuestions: 'Preguntas Adicionales',
    anonymous: 'Anónimo',
    noName: 'Sin Nombre',
    promoters: 'promoteres',
    neutral: 'neutral',
    detractors: 'detractores',
    invalid: 'inválido',
    system: 'Sistema',
    alertEmail: 'Correo electrónico de alerta enviado a {itemChange}.',
    statusUpdate: 'Status cambiado a {itemChange}.',
    answerCategory: 'Respuesta categorizada como {itemChange}.',
    removedCategory: 'Categoria {itemChange} eliminada para la respuesta.',
    newComment: 'Nuevo comentario adicionado para la respuesta: {itemChange}',
    responsibleDealt:
      'Responsable por la tratativa modificado para {itemChange}.',
    responseCollected:
      'Esa respuesta fue recolectada manualmente por {itemChange}',
    resurveySubmitted: 'Repesquisa disparada com sucesso!',
    removedAnswer: 'Respuesta removida',
    restoredAnswer: 'Respuesta restaurada',
    resurveyScheduled: 'Investigación programada con éxito.',
    transfer: 'Cambio de Filial',
    options: 'Opciones',
    userReplyTratativa: 'El usuario respondió a la tratativa',
    unreadTratativa: 'Tiene una tratativa no leída',
    messages: {
      updateComment: {
        title: 'Comentario Modificado!',
        description: 'Su comentario fue modificado',
      },
      errorUpdateComment: {
        title: 'Oops! Algo salió mal!',
        description: 'Intente nuevamente más tarde!',
      },
    },
    indicators: 'Indicadores',
    overview: {
      total: 'Total',
      answered: 'Respondidas',
      opened: 'Abiertas',
      staggered: 'Escalonadas',
      analysis: 'En análisis',
      others: 'Outros',
    },
    statusSelect: {
      select: 'Filtro por status',
      all: 'Todos',
      answered: 'Respondido',
      analysis: 'En análisis',
      staggered: 'Escalonada',
      opened: 'Abierto',
    },
    treatmentTable: {
      labels: {
        id: 'ID',
        date: 'Fecha',
        grade: 'Nota',
        client: 'Cliente',
        comment: 'Comentario',
        responsible: 'Responsable',
        category: 'Categorias',
        status: 'Status',
        days: 'Duración',
        options: 'Opciones',
      },
      dropdown: {
        options: {
          answered: 'Respondido',
          analysis: 'En análisis',
          staggered: 'Escalonada',
          opened: 'Abierto',
        },
        status: {
          aberto: 'Abierto',
          respondido: 'Respondido',
          em_analise: 'En análisis',
          escalonada: 'Escalonada',
          expirado: 'Expirado',
          resp_fora_prazo: 'Resp. Fuera de tiempo',
        },
      },
    },
    resurveyWarning: {
      title: '¡Hay una búsqueda configurada!',
      description:
        'Esta acción generará automáticamente un nuevo disparador de "Búsqueda" para ese cliente y no será posible volver a cambiar el status. ¿Quiere cambiar el estado a respondido y activar la búsqueda?',
      cancelButton: 'Cancelar',
      saveButton: 'Cambiar status',
    },
  },
  closetheloop: {
    steps: {
      selectAnswers: 'Seleccionar respuestas',
      configTemplate: 'Configurar plantilla',
      reviewSubmission: 'Review Submission',
    },
    selectAnswers: {
      answersLength:
        'Seleccionaste {longitud} respuesta (s) para cerrar el ciclo.',
      selectAll: 'Seleccionar todo',
      allSelected:
        'Ha seleccionado {totalAnswers} respuestas para cerrar el ciclo.',
      cleanSelection: 'Borrar selección',
      validationText: 'Seleccione al menos una respuesta',
      selectLabel: 'Selecionar',
      closureType: 'Qué tipo de cierre te gustaría hacer?',
      byEmail: 'Por email',
      onlyStatus: 'Solo estado de la oferta',
    },
    configureTemplate: {
      emailSubject: 'Asunto',
      emailSubjectPlaceholder: 'Ingrese el asunto del correo electrónico',
      emailSender: 'Remitente',
      emailSenderPlaceholder: 'Ingrese el nombre del remitente',
      templateDescription:
        'Configure y guarde sus plantillas para que pueda volver a utilizarlas de forma rápida y cómoda.',
      myTemplatesTitle: 'Mis plantillas',
      myTemplatesDescription:
        'Seleccione una plantilla a continuación para ver el formato del correo electrónico y realizar cambios si es necesario.',
      selectTemplate: 'Seleccionar una plantilla',
      saveTemplate: 'Guardar plantillas',
      saveTemplatePlaceholder: 'Ingrese el nombre de la plantilla',
      saveButton: 'Guardar',
      templatedCreatedTitle: '¡Éxito!',
      templatedCreatedDescription: '¡La nueva plantilla se creó correctamente!',
      statusTitle: 'Estado de cierre de bucle',
      statusDescription:
        'Seleccione a continuación cuál será el estado predeterminado de las respuestas después de enviar el correo electrónico.',
      responsibleTitle: 'Responsable',
      responsibleDescription:
        'Una vez que se lleva a cabo el disparo, el usuario será asignado automáticamente como responsable de estas negociaciones.',
      errorDescription:
        'Ingrese el asunto y el remitente del correo electrónico.',
      saveErrorDescription:
        'Introduzca el nombre de la plantilla, el asunto del correo electrónico y el remitente.',
    },
    reviewSubmission: {
      description:
        'Revise los datos a continuación antes de enviarlos y asegúrese de que los filtros aplicados sean correctos. Una vez que se ha activado el correo electrónico, no es posible cancelar el proceso. ',
      answersTotal: 'Total de clientes afectados',
      applyFilters: 'Filtros aplicados',
      action: 'Acción',
      metric: 'Métrica',
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de finalización',
      allPeriod: 'Todo el Período',
      search: 'Buscar',
      ih1: 'Filial',
      ih2: 'IH2',
      profile: 'Perfil',
      indicator: 'Indicador',
      configTemplate: 'Plantilla configurada',
      sendStatus: 'Estado por envío',
      responsible: 'Responsable',
      category: 'Categoría',
      subCategory: 'Subcategoría',
      comment: 'Comentario',
      anonymous: 'Anónimo',
      submitTitle: '¡Éxito!',
      submitDescription:
        'El close the loop se está disparando y en breve los clientes seleccionados recibirán el correo electrónico.',
    },
    nextButon: 'Siguiente',
    goBackButton: 'Atrás',
    sendButton: 'Enviar',
  },
  reports: {
    npsPonder: {
      reportTitle: 'NPS Ponderado',
      action: 'Acción',
      groupAction: 'Grupo de Acción',
      channel: 'Canal',
      weight: 'Peso',
      answers: 'Respostas',
      promoters: 'Promotores',
      passive: 'Neutros',
      detractors: 'Detractores',
    },
    hts: {
      reportTitle: 'Reporte HTS',
    },
    selectReport: 'Seleccione un reporte',
    emptyMsg: 'Seleccione en la lista una visión de reporte',
    pageTitle: 'Reportes',
    subTitle: 'Reporte',
    searchInput: 'Haga una busqueda...',
    searchButton: 'Limpiar',
    selectProfile: 'Seleccione un perfil',
    answersLabel: 'Respuestas',
    inviteLabel: 'Envíos',
    promoterLabel: 'Promotores',
    neutralLabel: 'Neutros',
    detractorLabel: 'Detractores',
    noteDetractorCesLabel: 'Notas 1 e 2',
    noteNeutralCesLabel: 'Nota 3',
    notePromoterCesLabel: 'Notas 4 e 5',
    monthlyLabel: 'Mensual',
    dailyLabel: 'Diario',
    weeklyLabel: 'Semanal',
    quarterlyLabel: 'Trimestral',
    accLabel: 'Acumulado',
    accMonthlyLabel: 'Mensual Acumulado',
    accDailyLabel: 'Diario Acumulado',
    accWeeklyLabel: 'Semanal Acumulado',
    accQuarterlyLabel: 'Trimestral Acumulado',
    downloadLabel: 'Download',
    sucessLabel: 'Éxito',
    errorLabel: 'Oops',
    cancelLabel: 'Cancelar',
    dontHaveData: 'Usted aún no tiene datos para ser mostrados aqui.',
    downloadMsg:
      'El archivo está siendo preparado! Usted puede acompañar el status de procesamiento en el menu "Downloads".',
    npsLabel: 'NPS',
    csatLabel: 'CSAT',
    csatAverageLabel: 'CSAT (Promedio)',
    loadingLabel: 'Cargando',
    noteCloudPromoter: 'Notas 4 y 5',
    noteCloudNeutral: 'Nota 3',
    noteCloudDetractor: 'Notas 1 y 2',
    exportXlsLabel: 'Exportar tabla para XLS',
    bounceEmail: 'Posibles errores de correo electrónico',
    invalidAccount: 'Cuenta inválida',
    invalidDomain: 'Dominio inválido',
    mailBoxFull: 'Buzón lleno',
    antiSpamBlocking: 'Bloqueo Anti-Spam',
    accountUnavailable: 'Cuenta no disponible',
    unavailableServer: 'Servidor no disponible',
    deliveryFailure: 'Entrega fallida',
    reportImpactReminder: 'Impacto de los recordatorios en la conversión',
    cardPercentageWithReminder: '% RESPUESTAS CON RECORDATORIOS',
    cardPercentageOfNoReminder: '% RESPUESTAS SIN RECORDATORIOS',
    quantityInvites: 'Cantidad de invitaciones',
    answeredInvites: 'Invitaciones respondidas',
    unansweredInvitations: 'Invitaciones sin respuesta',
    conversionPercentage: 'Porcentaje de conversión',
    reminderName: 'Lembrete',
    // when translating, please keep "key" contents, translate only "value" contents
    fullMonthNames: [
      {
        key: 'janeiro',
        value: 'Enero',
      },
      {
        key: 'fevereiro',
        value: 'Febrero',
      },
      {
        key: 'março',
        value: 'Marzo',
      },
      {
        key: 'abril',
        value: 'Abril',
      },
      {
        key: 'maio',
        value: 'Mayo',
      },
      {
        key: 'junho',
        value: 'Junio',
      },
      {
        key: 'julho',
        value: 'Julio',
      },
      {
        key: 'agosto',
        value: 'Agosto',
      },
      {
        key: 'setembro',
        value: 'Septiembre',
      },
      {
        key: 'outubro',
        value: 'Octubre',
      },
      {
        key: 'novembro',
        value: 'Noviembre',
      },
      {
        key: 'dezembro',
        value: 'Diciembre',
      },
    ],
    // when translating, please keep "key" contents, translate only "value" contents
    reportTitles: [
      {
        key: 'Evolução de NPS',
        value: 'Evolución de NPS',
        cesValue: 'Evolución de CES',
        csatValue: 'Evolución de CSAT',
        fiveStarsValue: 'Evolución de 5Stars',
      },
      {
        key: 'Evolução de Respostas',
        value: 'Evolución de Respuestas',
      },
      {
        key: 'Evolução de Percentuais',
        value: 'Evolución de Porcentajes',
      },
      {
        key: 'Rankings',
        value: 'Rankings',
      },
      {
        key: 'Comparativo de Ações',
        value: 'Comparativo de Acciones',
      },
      {
        key: 'Comparativo de Categorias',
        value: 'Comparación de categorías',
      },
      {
        key: 'Categorias',
        value: 'Categorias',
      },
      {
        key: 'Nuvem de Palavras',
        value: 'Nube de Palabras',
      },
      {
        key: 'NPS por Indicadores',
        value: 'NPS por Indicadores',
        cesValue: 'CES por Indicadores',
        csatValue: 'CSAT por Indicadores',
        fiveStarsValue: '5Stars por Indicadores',
      },
      {
        key: 'Relatório de Mapa - NPS',
        value: 'Reporte de Mapa - NPS',
        cesValue: 'Reporte de Mapa - CES',
        csatValue: 'Reporte de Mapa - CSAT',
        fiveStarsValue: 'Reporte de Mapa - 5Stars',
      },
      {
        key: 'Evolução de Perguntas Adicionais',
        value: 'Evolución de Preguntas Adicionales',
      },
      {
        key: 'Comparativo Indicadores',
        value: 'Comparativo Indicadores',
      },
      {
        key: 'Detratores Recorrentes',
        value: 'Detractores Recorrentes',
      },
      {
        key: 'Quadro Resumo',
        value: 'Cuadro Resumen',
      },
      {
        key: 'Comparativo Regional e Nacional',
        value: 'Comparativo Regional y Nacional',
      },
      {
        key: 'CXI – Pós Vendas',
        value: 'CXI - Pós Ventas',
      },
      {
        key: 'Status dos Disparos',
        value: 'Status de los Envíos',
      },
      {
        key: 'Status de Tratativas',
        value: 'Status de las Tratativas',
      },
      {
        key: 'Relatório CXI',
        value: 'CXI – Pós Ventas',
      },
      {
        key: 'Relatório CXI - Vendas',
        value: 'Informe de Ventas CXI',
      },
      {
        key: 'Relatório CXI Vendas - Caminhoes',
        value: 'Informe de ventas CXI - Caminhoes',
      },
      {
        key: 'Relatório CXI Vendas - Vans',
        value: 'Informe de ventas CXI - Vans',
      },
      {
        key: 'Análise de sentimento',
        value: 'Análisis de sentimiento',
      },
      {
        key: 'Analise por dispositivo',
        value: 'Analizar por dispositivo',
      },
      {
        key: 'Relatório Auditoria',
        value: 'Informe de auditoría',
      },
      {
        key: 'Relatório Comparativo de N1 e N2',
        value: 'Informe Comparativo de N1 y N2',
      },
      {
        key: 'Relatório Impacto dos Lembretes',
        value: 'Informe de impacto de recordatorios',
      },
      {
        key: 'Status de Tratativas',
        value: 'Estado de la negociación',
      },
      {
        key: 'Evolução de Categorias',
        value: 'Evolución de categorías',
      },
      {
        key: 'Evolução de Convites',
        value: 'Evolución de las invitaciones',
      },
      {
        key: 'Tags de Tratativas',
        value: 'Etiquetas de tratamiento',
      },
    ],
    basicColumn: {
      reportTitle: 'Evolución de NPS',
      cesReportTitle: 'Evolución de CES',
      csatReportTitle: 'Evolución de CSAT',
      csatValueAverage: 'Evolución de CSAT(average)',
      fiveStarsValue: 'Evolución de 5Stars',
    },
    answerEvolution: {
      reportTitle: 'Evolución de Respuestas',
    },
    invitesEvolution: {
      reportTitle: 'Evolución de Envíos',
    },
    percentageEvolution: {
      reportTitle: 'Evolución de Porcentajes',
    },
    tags: {
      reportTitle: 'Reporte de Tags',
      allTags: 'Todas las Tags',
      subtags: 'Subtags',
      totalClassified: 'Total de tratativas clasificadas',
    },
    categories: {
      reportTitle: 'Reporte de Categorias',
      allCategories: 'Todas las Categorias',
      scorelabel: 'Score',
      totalLabel: 'Total',
      totalCategorized: 'Total de Respuestas Categorizadas',
      promoterCategorized: 'Total de Respuestas Promotoras Categorizadas',
      neutralCategorized: 'Total de Respuestas Neutras Categorizadas',
      detractorCategorized: 'Total de Respuestas Detractoras Categorizadas',
      notes4and5: 'Nota 4 y 5',
      note3: 'Nota 3',
      notes1and3: 'Nota 1 y 3',
      subcategories: 'Subcategorias',
      optionText:
        'Categoría (Base frecuencia) - Calculo: Categoría/Total categorías.\n' +
        'Categoria (Base respuestas) - Calculo: Categoría/Total respuestas.',
      frequencyOption: 'Categoría (Base frecuencia)',
      normalOption: 'Categoria (Base respuestas)',
      totalCategories: 'Total de Categorías',
    },
    conversionDetails: {
      reportTitle: 'Reporte de Conversión / Detalles de importación',
      searchAction: 'Buscar ação',
    },
    categoriesEvolution: {
      reportTitle: 'Reporte de Evolución de Categorias',
      optionText:
        'Categoría (Base frecuencia) - Calculo: Categoría/Total categorías.\n' +
        'Categoria (Base respuestas) - Calculo: Categoría/Total respuestas.',
      frequencyOption: 'Categoría (Base frecuencia)',
      normalOption: 'Categoria (Base respuestas)',
      profileLabel: 'Perfil',
      selProfileLabel: 'Seleccione perfil',
      promoterLabel: 'Promotor',
      neutralLabel: 'Neutro',
      detractorLabel: 'Detractor',
      categoryLabel: 'Categoria',
      selCategoryLabel: 'Seleccione categoría',
    },
    categoriesTags: {
      categories: 'Entrada: Categorías',
      subCategories: 'Entrada: SubCategorías',
      tags: 'Salida: Tags de Tratativas',
      loadAllCategories: 'Cargar todas las Categorías',
      profileLabel: 'Perfil',
      selProfileLabel: 'Seleccione perfil',
      promoterLabel: 'Promotor',
      neutralLabel: 'Neutro',
      detractorLabel: 'Detractor',
    },
    indicators: {
      reportTitle: 'Reporte de Indicadores',
      indicatorLabel: 'Indicador',
      byIndicators: 'por indicadores',
      descriptionLabel: 'Descricción',
      selIndicatorLabel:
        'Por favor, seleccione algún indicador para mostrar los datos.',
      noDatalabel: 'Ningún dato a ser mostrado',
      noAnswerLabel:
        'Ninguna respuesta asociada a este indicador fue encontrada.',
      selIndicatorSelectLabel: 'Seleccione un indicador',
      answerDownloadlabel: 'Download de las respuestas',
    },
    multipleSubOptions: {
      multipleSubOptions: 'Múltiple con subopciones',
      optionFrequency: 'Opción (frecuencia base)',
      optionAnswer: 'Opción (Respuesta base)',
    },
    comparativeIndicators: {
      reportTitle: 'Comparativo de Indicadores',
      valueLabel: 'Valor',
      fillFieldsMsg:
        'Por favor, llene los campos arriba para exhibir el reporte.',
      selIndicatorLabel: 'Seleccione un indicador',
      selValueLabel: 'Seleccione un valor',
    },
    comparativeN1N2: {
      title: 'Comparativo de N1 y N2 - Analisis de Porcentaje',
      yAxisLabel: ' N1 N2',
    },
    comparativeCategories: {
      categoryLabel: 'Categoria',
      reportTitle: 'Comparativo de Categorías - Analisis de Porcentaje',
      reportTitleMultiple: 'Comparativo de Opción - Analisis de Porcentaje',
      fillFieldsMsg:
        'Por favor, llene los campos arriba para exhibir el reporte.',
      selCategoryLabel: 'Seleccione categoría',
      profileLabel: 'Perfil',
      selProfileLabel: 'Seleccione perfil',
      promoterLabel: 'Promotor',
      neutralLabel: 'Neutro',
      detractorLabel: 'Detractor',
      subcategoryLabel: 'Subcategoría',
      selSubcategoryLabel: 'Seleccione subcategoría',
      analyzeLabel: 'Analisar',
      allLabel: 'Todos',
      yAxisLabel: 'Categorizado',
    },
    detractor: {
      reportTitle: 'Detractores Recorrentes',
      loadingLabel: 'Loading',
      noDataLabel: 'Ningún dato a ser exhibido',
      noDataMsg: 'Ningún dato fue encontrado para los filtros seleccionados.',
      answerDetailsLabel: 'Detalles de la respuesta',
      seriesNameLabel: 'Cantidad de detractores recorrentes',
      tableCustomerLabel: 'Cliente',
      tableDateLabel: 'Fecha',
      tableReviewLabel: 'Nota',
      tablePreviousDateLabel: 'Fecha de la nota anterior',
      tablePreviousReviewLabel: 'Nota',
      tableDetailsLabel: 'Detalles',
    },
    evolAddQuestion: {
      reportTitle: 'Reporte de Preguntas Adicionales',
      additionalQuestionlabel: 'Pregunta Adicional',
      loadingLabel: 'Loading',
      selSelectAddQuestionLabel: 'Seleccione una Pregunta Adicional',
      selAddQuestionLabel:
        'Por favor, selcecione alguna Pregunta Adicional para exhibir los datos.',
      graphTitle: 'Evolución de Pregunta Adicional',
      title: 'Evolución de Preguntas Adicionais',
    },
    groupNps: {
      reportTitle: 'Reporte Comparativo Regional y Nacional',
      selIh1Label:
        'Por favor, seleccione algún Concesionario/Dealer en la opción de filtros.',
      generalTitleLabel: 'Nacional',
    },
    horizontalBar: {
      chartTitle: 'NPS - Porcentaje',
      cesChartTitle: 'CES - Percentual',
      csatChartTitle: 'CSAT - Porcentaje',
      chartSeries: 'Porcentaje',
      ceschartSeries: 'Cantidad',
      chartNoData: 'NPS - Porcentual (sin datos para exhibir)',
      cesChartNoData: 'CES - Percentual (sin datos para exhibir)',
      csatChartNoData: 'CSAT - Percentual (sin datos para exhibir)',
      csatchartSeries: 'Cantidad',
      fiveStarsTitle: '5-Stars Porcentual',
      fiveStarsNoData: '5 Stars - Percentual (sin datos para exhibir)',
      fiveStarschartSeries: 'Cantidad',
      likeDislikeTitle: 'Like/Dislike Porcentual',
      likeDislikeNoData: 'Like/Dislike - Percentual (sin datos para exhibir)',
      likeDislikechartSeries: 'Cantidad',
      csatPromoters: '9 e 10',
      csatPassives: '7 e 8',
    },
    inviteStatus: {
      reportTitle: 'Status de Envíos',
      noDataLabel: 'Ningún dato a ser exhibido',
      noDataMsg: 'Ningún dato fue encontrado para los filtros seleccionados.',
      seeDetailsLabel: 'Ver detalles',
      emailLabel: 'E-mail',
      smsLabel: 'SMS',
      invitesLabel: 'Envíos',
      deliveredLabel: 'Entregado',
      openedLabel: 'Abiertos',
      clickedLabel: 'Clicados',
      bounceLabel: 'Erro',
      spamLabel: 'Spam Reports',
      notDeliveredLabel: 'No Entregado',
      phoneLabel: 'Teléfono',
      detailDeliveredLabel: 'Detalles de las invitaciones entregadas',
      detailOpenedLabel: 'Detalles de las invitaciones abiertas',
      detailClickedLabel: 'Detalles de las invitaciones clicadas',
      detailSpamLabel: 'Detalles de las invitaciones colocadas en spam',
      detailBounceLabel: 'Detalles de las invitaciones en bounce',
      detailNotReceivedLabel: 'Detalles de las invitaciones no recibidas',
      detailDefaultLabel: 'Detalles de las invitaciones',
      deliveryPercentLabel: 'Porcentaje de entrega',
      customerLabel: 'Cliente',
      inviteIdLabel: 'ID de la invitación',
      sentDateLabel: 'Fecha de envío',
      invitesLabelInfoEmail:
        'Número de disparos realizados al correo del cliente a través de la API de IndeCX. ',
      deliveredLabelInfo:
        'Número de envíos exitosos generados por el servidor de correo del destinatario. ',
      openedLabelInfo:
        'Número de correos electrónicos abiertos por el destinatario. ',
      clickedLabelInfo:
        'Número de veces que el destinatario hizo clic en el enlace para responder la encuesta dentro de su correo electrónico.',
      bounceLabelInfo:
        'Número de veces que el servidor no puede recibir o aceptar el mensaje. ',
      spamLabelInfo:
        'Número de veces que el destinatario marcó el correo electrónico como spam. ',
      invitesLabelInfoSMS:
        'Número de disparos realizados para el número de cliente a través de la API de IndeCX. ',
      deliveredLabelInfoSMS:
        'Número de envíos exitosos generados por el servidor de SMS del destinatario. ',
      notDeliveredLabelInfo:
        'Número de SMS que no se entregaron al destinatario. ',
    },
    mapChart: {
      brasil: 'Brasil',
      mapMundi: 'Mapa del mundo',
      reportTitle: 'Reporte de Mapa - {metric}',
      subtitleLabel: 'Subtítulo',
      npslt0: 'NPS menor que 0',
      npslt50: 'NPS de 0 a 49',
      npslt70: 'NPS de 50 a 69',
      npslt80: 'NPS de 70 a 79',
      npsge80: 'NPS de 80 a 100',
      ufLabel: 'UF',
      localeLabel: 'Pais',
    },
    treatmentMonitoring: {
      treatment: 'Tratados',
      averageTreatment: 'Promedio de tratamientos realizados',
      averageTreatmentDesc:
        'Promedio de tratos con Estado Respondido en el periodo seleccionado',
      totalPeriod: 'Total en periodo',
      startAverage: 'Tiempo promedio para comenzar el tratamiento',
      startAverageDesc:
        'Tiempo entre el registro de la primera operación y la fecha de la respuesta.',
      hours: 'horas',
      averageAnswer: 'Tiempo de respuesta promedio',
      averageAnswerDesc:
        'Tiempo medio entre la finalización del tratamiento con Estado Respondido y la fecha de respuesta.',
      averageNoStart: 'Tiempo promedio sin iniciar tratamiento',
      averageNoStartDesc:
        'Tiempo entre la fecha actual y la fecha de la respuesta al tratamiento',
      averagePending: 'Tiempo promedio de tratos pendientes',
      averagePendingDesc:
        'Tiempo entre la fecha actual y la fecha de inicio de la primera negociación en el periodo seleccionado',
      operatorStatus: 'Estado del operador',
      currentStatus: 'Estado actual',
      treatmentCard: 'Treatative',
      averagePeriod: 'Promedio de negociaciones en el periodo',
      massTreatment: 'Tratamientos masivos en periodo',
      profile: 'Perfil',
    },
    monthlyDetractors: {
      reportTitle: 'Detractores Mensuales',
      noDataLabel: 'Detractores Mensuales - Ningún dato a ser exhibido',
      noDataMsg: 'Ningún dato fue encontrado para los filtros seleccionados.',
      chartTitle: 'Detractores Mensuales',
      chartSeries: 'Cantidad de detractores',
    },
    csat: {
      csatLabelReport: 'Escala 0 a 10',
      addQuestionLabel: 'Pregunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total de Respuestas',
    },
    nps: {
      npsLabelReport: 'NPS',
      addQuestionLabel: 'Pregunta adicional',
      promoterLabel: 'Promotor',
      neutralLabel: 'Neutro',
      detractorLabel: 'Detractor',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total de Respuestas',
    },
    ces: {
      cesLabelReport: 'Escala Ces 1 a 5',
      addQuestionLabel: 'Pregunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total de Respuestas',
    },
    emotion: {
      emotionLabel: 'Emotion',
      addQuestionLabel: 'Pregunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total de Respuestas',
    },
    likeDislike: {
      likeDislikeLabel: 'Like Dislike',
      addQuestionLabel: 'Pregunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total de Respuestas',
    },
    likeDislikeGroup: {
      likeDislikeLabel: 'Like Dislike',
      addQuestionLabel: 'Pregunta adicional',
      branchLabel: 'Sucursal',
      groupLabel: 'Regional',
      companyLabel: 'Nacional',
    },
    likert: {
      likertLabel: 'LIKERT',
      addQuestionLabel: 'Pregunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total de Respuestas',
    },
    reviews: {
      reviewsLabel: 'REVIEWS',
      addQuestionLabel: 'Pregunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total de Respuestas',
    },
    reviewsGroup: {
      reviewsLabel: 'REVIEWS',
      addQuestionLabel: 'Pregunta adicional',
      branchLabel: 'Sucursal',
      groupLabel: 'Regional',
      companyLabel: 'Nacional',
    },
    summaryBoard: {
      reportTitle: 'Cuadro Resumen - Gerencial',
      invitesLabel: 'Invitaciones',
      answersLabel: 'Respuestas',
      conversionLabel: 'Conversión',
      receivedEmails: 'E-mails Recibidos',
      receivedPhones: 'Celulares Recibidos',
      channelQtLabel: 'Cantidad por canal de colecta',
      emailLabel: 'E-mail',
      smsLabel: 'SMS',
      manualLabel: 'Manual',
      othersLabel: 'Otros',
      promoterLabel: 'Promotor',
      neutralLabel: 'Neutro',
      detractorLabel: 'Detractor',
      top5detractors: 'Top 5 Categorias - Detratores',
      top5promoters: 'Top 5 Categorias - Promotores',
      top5passives: 'Top 5 Categorias - Neutros',
      categorizedLabel: '% de las ocurrencias fueron categorizadas',
      positionMsg1: 'Su posición es',
      positionMsg2: 'en el ranking nacional en el período seleccionado',
    },
    npsBar: {
      reportTitle: 'NPS - Net Promoter Score',
      csatReportTitle: 'CSAT - Customer Satisfaction Score',
      csatAverageReportTitle: 'CSAT(Average) - Customer Satisfaction Score',
      csat0to10ReportTitle: 'CSAT(0 a 10) - Customer Satisfaction Score',
      csat0to10AverageReportTitle: 'CSAT(0 a 10) - Customer Satisfaction Score',
      fiveStarsReportTitle: '5-Stars',
      npsMessage: 'Su nps es de',
      csatMessage: 'Su csat es de',
      fiveStarsMessage: 'Su 5 stars es de',
      noDataMsg: 'Sin datos para exhibir',
      noData: 'Sin datos en el periodo',
      promoterLabel: 'Promotor',
      neutralLabel: 'Neutro',
      detractorLabel: 'Detractor',
      totalAnswersLabel: 'Total de Respuestas',
    },
    treatmentStatus: {
      noDataLabel: 'Ningún dato a ser exhibido',
      noDataMsg: 'Ningún dato fue encontrado para los filtros seleccionados.',
      allSelected: 'Todos los perfiles',
      promoterLabel: 'Promotor',
      neutralLabel: 'Neutro',
      detractorLabel: 'Detractor',
      answeredLabel: 'Respondido',
      openedLabel: 'Abierto',
      analysedLabel: 'En análisis',
      others: 'Otros',
      staggeredLabel: 'Escalonado',
      chartTitle: 'Status de tratativas mensual',
    },
    verticalColumn: {
      chartTitle: 'NPS - Notas',
      chartSeries: 'Cantidad',
      csatChartTitle: 'CSAT - Notas',
      likeDislikeReportTitle: 'Like/Dislike - Notas',
    },
    wordCloud: {
      anonimousLabel: 'Anónimo',
      noDataMessage: 'Ninguna palabra seleccionada.',
      commentLabel: 'Comentario',
      dateLabel: 'Fecha',
      gradeLabel: 'Nota',
      customerLabel: 'Cliente',
      detailsLabel: 'Detalles',
    },
    cxiReport: {
      reportTitle: 'Indicador CXI de Posventa',
      cxiLabel: 'CXI',
      noDataMsg: 'Sin datos para exhibir',
      reportHeader1: 'Informe de Postventas CXI',
      reportHeader2:
        'El indicador CXI está compuesto por 3 indicadores: Satisfacción General (50%), Recomendación (25%) y Revisit (25%).',
      questionHeader: 'Pregunta',
      score: 'Score',
      index: 'Índice consolidado',
      satisfaction: 'Satisfacción',
    },
    cxiReport2024: {
      reportTitle: 'Indicador CXI de Posventa',
      cxiLabel: 'Indicador por mes',
      noDataMsg: 'Sin datos para mostrar',
      reportHeader1: 'Informe CXI de Posventa',
      reportHeader2:
        ' El Indicador Final se compone de la siguiente manera: (Promedio del Ítem A * 30%) + (Promedio del Ítem B * 70%)',
      questionHeader: 'Pregunta',
      score: 'Puntuación',
      graphicTitle: 'Indicador final - 360',
      indexByMonth: 'Índice por mes',
      questionA: 'Preguntas - Ítems A (Preguntas adicionales)',
      questionB: 'Preguntas - Ítems B (CXI)',
    },
    cxiSalesReport: {
      reportTitle: 'Indicador CXI de Ventas',
      cxiLabel: 'CXI',
      noDataMsg: 'Sin datos para exhibir',
      reportHeader1: 'Informe de Ventas CXI',
      reportHeader2:
        'El indicador CXI está compuesto por 3 indicadores: Satisfacción General (50%), Recomendación (25%) y Revisit (25%)',
      reportHeader3:
        'La calificación se basa en la suma de todas las encuestas respondidas según el período filtrado.',
      questionHeader: 'Pregunta',
      score: 'Score',
    },
    ccsi: {
      reportTitle: 'Indicador CCSI',
      ccsiLabel: 'CCSI',
      addQuestionLabel: 'Pregunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
    },
    hgsi: {
      reportTitle: 'Indicador HGSI',
      hgsiLabel: 'Índice HGSI',
      scsiLabel: 'Índice SCSI',
      addQuestionLabel: 'Pregunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
    },
    prehgsi: {
      reportTitle: 'Indicador PRE-HGSI',
      prehgsiLabel: 'Índice PRE-HGSI',
      addQuestionLabel: 'Pregunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
    },
    fcsi: {
      reportTitle: 'Indicador FCSI',
      fcsiLabel: 'Índice FCSI',
      addQuestionLabel: 'Pregunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
    },
    multiples: {
      multiplesLabel: 'Multiples Opciones',
      addQuestionLabel: 'Pregunta adicional',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total de Respuestas',
    },
    partsAvailability: {
      filterTitle: 'Filtrar por subsegmento',
      filterPlaceholder: 'Seleccionar un subsegmento',
      reportTitle: 'Disponibilidad de piezas',
      table: {
        date: 'Fecha',
        review: 'Nota',
        customer: 'Cliente',
        comment: 'Comentario',
        details: 'Detalles',
      },
    },
    sentmentAnalysis: {
      reportTitle: 'Análisis de sentimiento',
      reportDescription:
        'IndeCX usa Inteligencia Artificial para clasificar sentimientos y extraer palabras clave basadas en comentarios. La puntuación a continuación indica el nivel de sentimiento, que puede variar de -100 a 100.',
      total: 'Total',
      percentAnalyzed: 'se analizaron las respuestas.',
      positive: 'Positivo',
      neutral: 'Neutral',
      negative: 'Negativo',
      classificationReportTitle: 'Clasificación de sentimiento',
      classificationReportTitleMonthly:
        'Clasificación del sentimiento a lo largo del tiempo',
      sentmentScoreReportTitle: 'Puntuación de sentimiento',
      sentmentScoreReportTitleMonthly: 'Puntuación de sentimiento por mes',
      keywordsTablePositive: {
        keywords: 'Keywords positivas',
        percentage: '%',
        total: 'Total',
      },
      keywordsTableNeutral: {
        keywords: 'Keywords neutrales',
        percentage: '%',
        total: 'Total',
      },
      keywordsTableNegative: {
        keywords: 'Keywords negativas',
        percentage: '%',
        total: 'Total',
      },
      indicatorTitle: 'Sentimiento por indicador',
      selectTitle: 'Indicador:',
      selectPlaceholder: 'Seleccione un indicador',
      indicatorTable: {
        indicator: 'Indicador',
        description: 'Descripción',
        score: 'Score',
        total: 'Total',
      },
    },
    deviceAnalysis: {
      deviceTitle: 'Respuestas del dispositivo',
      deviceSubText: 'Dispositivo utilizado para responder a la encuesta',
      qty: 'La cantidad',
      browserTitle: 'Respuesta del navegador',
      browserSubText: 'Navegador utilizado para la respuesta de búsqueda',
      soTitle: 'Respuesta por sistema operativo',
      soSubText: 'Sistema operativo utilizado en dispositivos',
      selectDevice: 'Seleccionar el dispositivo',
      all: 'Todas',
    },
  },
  aiReports: {
    aiAnalysis: 'Analisis IA',
    swotAnalysis: 'Analisis SWOT',
    swotAnalysisText:
      'Análise SWOT é uma técnica de planejamento estratégico utilizada para auxiliar pessoas ou organizações a identificar forças, fraquezas, oportunidades, e ameaças relacionadas à competição em negócios ou planejamento de projetos.',
    summarization: 'Sumarização',
    summarizationText:
      'Sumarização é uma técnica de planejamento estratégico utilizada para auxiliar pessoas ou organizações a identificar forças, fraquezas, oportunidades, e ameaças relacionadas à competição em negócios ou planejamento de projetos.',
    selectReport: 'Seleccione Reporte',
    comingSoon: 'Pronto',
    newAnalysis: 'Nueva Analisis',
    searchInput: 'Haga una busqueda',
    searchButton: 'Limpiar',
    swotTable: {
      labels: {
        id: 'ID',
        filters: 'Filtro para Analisis SWOT',
        createdAt: 'Creado en',
        period: 'Periodo',
        qtd: 'Muestra',
        status: 'Status',
        visualization: 'Visualización',
      },
      status: {
        processando: 'Processando',
        processado: 'Processado',
        falha: 'Falla',
      },
    },
    summarizationTable: {
      labels: {
        id: 'ID',
        filters: 'Filtro para Resumen',
        createdAt: 'Creado en',
        period: 'Periodo',
        qtd: 'Muestra',
        status: 'Status',
        visualization: 'Visualización',
      },
      status: {
        processando: 'Processando',
        processado: 'Processado',
        falha: 'Falla',
      },
    },
    newAiReport: {
      analysisFilter: 'Filtro de analisis',
      analysisRevision: 'Revisión de analisis',
      answersPeriod: 'Período de respuestas',
      filters: 'Filtros',
      actionGroup: 'Grupo de Acción',
      action: 'Acción',
      profile: 'Perfil',
      ih1: 'Sucursal',
      selectedItens: 'Filtros aplicados',
      actions: 'Acciones',
      revision: 'Revisión de datos',
      selectedFilters: 'Filtros seleccionados',
      cancelButton: 'Cancelar',
      nextButton: 'Siguiente',
      analyseButton: 'Analisar',
      goBackButton: 'Volver',
    },
  },
  genericMessages: {
    save: 'Guardar',
    cancel: 'Cancelar',
    success: {
      title: 'Éxito!',
      description: '¡Sus cambios han sido guardados con éxito!',
    },
    error: {
      title: 'Error',
      description: 'Hubo un error inesperado. ¡Vuelve a intentarlo más tarde! ',
    },
    goBack: 'Volver',
    noDataTitle: 'No hay información para mostrar',
    noDataDescription:
      'No se encontraron datos para los filtros seleccionados.',
  },

  informationAboutNpsDash: {
    aboutNps: 'Información sobre NPS',
    rangeNps: 'GAMA NPS',
    reference: '* Referencia INDECX',
    awfulTitle: 'Menor que 0 - Pésimo NPS:',
    awful:
      'Las empresas con un valor de NPS en esta zona tienen la mayoría de sus clientes detractores.​',
    badTitle: 'De 0 a 49 - Mal NPS:',
    bad: 'Las empresas de esta zona suelen tener una gran cantidad de promotores y detractores, pero también influye el número de neutrales.​',
    goodTitle: 'De 50 a 69 – Bueno NPS:',
    good: 'Empresas que se preocupan por brindar un excelente servicio. El número de promotores supera a los detractores',
    veryGoodTitle: 'De 70 a 79 – Muy buen NPS:',
    veryGood:
      'Empresas que oferecem um atendimento de referência na satisfação de clientes. Pouquíssimos detratores.​',
    excellentTitle: 'De 80 a 100 - Excelente NPS:',
    excellent:
      'Pocas empresas están en esta zona y se han convertido en un referente en el servicio al cliente que ofrecen.',
  },

  panel: {
    panelDataTime: {
      day: 'Diario',
      week: 'Semanal',
      month: 'Mensual',
      quarter: 'Mensual',
    },
    titleSideBar: 'Paneles',
    createCard: {
      choosePanel: 'Elija el tipo de panel',
      configPanel: 'Configuración del panel',
      useTemplate: 'Usar template',
      template:
        'Nuestro equipo de profesionales estrenó un template único pensando en su cliente.',
      soon: '¡Pronto!',
      createPanel: 'Crear Panel',
      create:
        'Cree su panel personalizable y obtenga una vista completa de la experiencia de su cliente.',
      createPanelButton: 'Crear Panel',
      title: 'Elige una de las siguientes opciones',
    },
    createCardSecondStep: {
      panelTitle: 'Título del panel',
      description: 'Descripción',
      accessPermission: 'Perfiles que tendrán acceso',
      createPanel: 'Crear panel personalizado',
      cancel: 'Cancelar',
      save: 'ahorrar',
    },
    createCardPanel: {
      modalTitle: 'Criar Card',
      modal:
        'Crea tu card personalizada para tu panel ingresa el nombre y elige las métricas que mejor se adapten a tus necesidades.',
      cardTitle: 'Titulo de lo card',
      metric: 'Elegir Métrica: ',
      metricDescription: 'Seleccionar Métrica',
      reportName: 'Elija el informe para mostrar',
      type: 'Elija el tipo: seleccione un análisis',
      timeChoise: 'Elija el período',
      typeData: {
        sentimentAnalyze: 'análisis de los sentimientos',
        sentimentAnalyzeReports: {
          sentimentClassification: 'Calificación de Sentimiento',
          sentimentEvolution: 'Evolución del sentimento',
          sentimentScore: 'Puntaje de sentimento',
          topFiveKey: 'Top 5 Keywords',
        },
        npsAnalytics: 'Análisis de NPS',
        cesAnalytics: 'Análisis de CES',
        csatAnalytics: 'Análisis de CSAT',
        fiveStarsAnalytics: 'Análisis 5-Stars',
        likeDislike: 'Análisis like y dislike',
        npsAnalyticsReports: {
          invitationsAnalysis: 'Análisis de indicadores',
          comparativeIndicators: 'Comparación de acciones',
          gradeDistribution: 'Distribución de calificaciones',
          invitesEvolution: 'Evolución de las invitaciones',
          npsEvolution: 'Evolución de nps',
          percentEvolution: 'Evolución de porcentajes',
          indexNps: 'Índice NPS',
          npsPercentage: 'NPS Porcentaje',
          mapReport: 'Informe de mapa',
          recurringDetractors: 'Detractores recorrentes',
        },
        categories: 'Categorías',
        categoriesReports: {
          categories: 'Categorías',
        },
        additionalQuestion: 'Preguntas Adicionales',
        additionalQuestionReports: {
          multipleChoice: 'Ranking Opción multiple',
          ces1a5: 'Ranking CES 1 a 5',
          emotion: 'Ranking Emotion',
          scale0a10: 'Ranking Escala 0 to 10',
          likeOrDeslike: 'Ranking Like/dislike',
          likert: 'Ranking Likert',
          nps: 'Ranking NPS',
          review: 'Ranking Review',
        },
        others: 'Otros',
        othersReports: {
          deviceAnalysis: 'Analizar por dispositivo',
          conversion: 'Conversión',
          evolutionOfAnswers: 'Evolución de la respuesta',
          keyCloud: 'Nube de palabras',
          replyByChannel: 'Responder por canales',
          treatmentStatus: 'Status de tratativas',
        },
      },
      chooseTime: {
        today: 'Hoy',
        yesterday: 'ayer',
        last30Days: 'Últimos 30 días',
        currentMonth: 'Mes actual',
        lastMonth: 'Mes pasado',
        currentYear: 'Años corriente',
        lastYear: 'El ano pasado',
        everyPeriod: 'Todo período',
        customized: 'Personalizado',
        choose: 'Elija el período',
      },
      editCard: {
        title: 'Editar tarjeta',
        description:
          'Edita tu tarjeta personalizada para tu tablero, ingresa el nombre y elige las métricas que mejor se adapten a tus necesidades.',
        titlePanel: 'Título del panel',
        chooseMetric: 'Elija la métrica',
        chooseTypeAnalysis: 'Elija el tipo de análisis',
        chooseReport: 'Elija el informe a mostrar',
        choosePeriod: 'Elegir periodo',
        chooseFilter: 'Elegir filtro',
        chooseAction: 'Elegir acción',
        chooseBranch: 'Elige la sucursal',
        chooseIndicator: 'Elija el indicador',
        showMore: 'Cargar más',
        chooseValueIndicator: 'Elija el valor del indicador',
        chooseTypeGraph: 'Elija el tipo de gráfico a utilizar',
        graphics: 'Graphics',
        save: 'Guardar',
        cancel: 'Cancelar',
      },
      chooseFilterTitle: 'Elijá el filtro',
      chooseFilter: {
        actionGroup: 'Grupo de acciones',
        action: 'Acción',
        indicator: 'Indicador',
        filial: 'filial',
      },
      panelHeader: {
        srcPanel: 'Buscar panel',
        edit: 'Editar',
        reload: 'Recargar',
        custom: 'Personalización',
        addGraphcs: 'Añadir grafíco',
        loadMore: 'Mirar más>>',
      },
      homePageCard: {
        metric: 'Métrica',
        actionGroup: 'Grupo de acciones',
        branch: 'Filial',
        area: 'Area',
        data: 'Data',
        action: 'Acción',
        title: 'Rellena un título',
        chooseGraphicsType: 'Elija el tipo de gráfico a utilizar',
      },
      formTextArea: {
        chooseAnalysis: 'Seleccione un análisis',
        choosePeriod: 'Seleccione un análisis',
        chooseFilterDescription: 'Seleccione el fitro',
        chooseMetric: 'Seleccione la métrica ',
        title: 'Rellena un título',
      },
      filterOptions: {
        actionGroupName: 'Elige un grupo',
        action: 'Seleccione una acción',
        indicator: 'Seleccione un indicador',
        filial: 'Seleccione una sucursal',
        chooseActionTitle: 'Elija a acción',
        chooseFilialTitle: 'Elija el  subsidiaria',
        chooseInicatorTitle: 'Elija el indicador',
        chooseIndicatorValue: 'Elija el valor del indicador',
        chooseValue: 'Elija un valor',
      },
      metrics: {
        selectMetric: 'Selección de una métrica',
        nps0to10: 'NPS - escala 0 a 10',
        nps1to5: 'NPS - escala 1 a 5',
        ces1to5: 'CES - escala 1 a 5',
        csat1To5: 'CSAT - escala 1 a 5(Top 2 box)',
        csat1To5Media: 'CSAT - escala 1 a 5(media)',
        fiveStars: '5-Stars',
        likeDislike: 'Like/Dislike 0 y 1',
      },
    },
    pageHome: {
      titlePage: 'Mis paneles - Beta',
      findPanel: 'Búsqueda de paneles',
      noHavePanel: '¡Vós no tienes ninguno painel personalizada!',
      morePanel: '+ Añadir panel',
      wouldDelete: '¿Está seguro de que desea eliminar este panel?',
      wouldDeleteCard: '¿Está seguro de que desea eliminar este card?',
      description:
        'Todos los cambios configurados se perderán y no podrá recuperarlos.',
      yes: 'Yes',
      no: 'No',
      date: 'Fecha',
    },
    generalButtons: {
      edit: 'Editar',
      delete: 'Borrar',
      addGraphics: 'Crear',
      save: 'ahorrar',
      reload: 'Recargar',
      custom: 'personalización',
      addGraphcs: 'Añadir gráfico',
      findPanel: 'Buscar Panel',
    },
  },

  actionTranslateUpdate: {
    multiLanguage: 'Multi Lenguaje',
    pauseAction: 'Pausar Accíon',
    yes: 'Sí',
    no: 'No',
    staticQuest:
      'Em uma escala de 1 a 5, quanto você indicatia a IndeCX para um amigo ou familiar?',
    requireAddQuest: 'Obligatorio por pregunta adicional',
    textBeforeEmoji:
      'Al habilitar esta opción, se mostrará en la configuración',
    textAfterEmoji:
      'de cada pregunta la posibilidad de hacer obligatoria esa pregunta adicional',
    options: {
      title: 'Opciones.',
      clone: 'Acción de clonación',
      groupCategory: 'Grupo de categorias',
      groupTagsTreatment: 'Grupo tags de tratativa',
      removeAction: 'Quitar acción',
      webHookRegister: 'Registro webhook',
      emailRegister: 'Registrar correo electrónico (remitente)',
      hideDefault: 'Ocultar por defecto',
    },

    logicRules: {
      modalTitle: 'Reglas lógicas',
      description:
        'Crea reglas para deshabilitar preguntas según la respuesta de tus clientes.',
      conditionals: 'Si la respuesta a la siguiente pregunta',
      is: 'Es',
      equal: 'Igual a',
      larger: 'Más grande que',
      largerOrEqual: 'Más grande ou igual a',
      smaller: 'Menos que que',
      smallerOrEqual: 'Menos que ou igual a',
      different: 'Diferente de',
      turnOff: 'Luego deshabilite las preguntas a continuación',
      selectAnswer: 'Seleccione una respuesta',
    },
    moreOptionsRules: {
      modalTitle: 'Más opciones',
      describe:
        'Habilite algunas de las opciones a continuación para agregar personalizaciones adicionales a su encuesta',
      addNewField: 'Agregar um campo de comentario',
      notApply: 'Agregar opción “No aplica”',
      notApplyDescribe:
        'Muestre la pregunta en función de una condición de la métrica principal.',
      labelText:
        'Muestre la pregunta solo si el perfil del encuestado es igual a:',
      seeAnswer:
        'Muestre la pregunta solo si el indicador seleccionado a continuación es igual o diferente del valor del parámetro:',
      indicator: 'Indicador:',
      indicatorDescribe: ' Las opciones cambian por compañía.',
      critrion: 'Criterio',
      equal: 'Igual a',
      different: 'Diferente de',
      contains: 'Contiene',
      params: 'Parámetro:',
    },
    templateTranslateRef: {
      templateTitle: 'Template de botón',
      buttonScale: 'Escala de grado',
      button: 'Botón',
      automaticAnswer: 'Respuesta automática',
      showIndecxLogo: 'Mostar logotipo IndeCX',
      noteRef: 'Nota de referencia',
      customSubmitButton: 'Personalizar botón enviar',
      default: 'Patrón',
      colors: '3 Colores',
    },
    quarentine: {
      dispatch: 'Disparo',
      period: 'Período en días',
      validity: 'Válidez:',
      options: {
        allData: 'General',
        thisAction: 'Por esta acción',
        actionGroup: 'Para el grupo de acción',
      },
      answer: 'Respuesta',
    },
  },

  acumulated: 'Acumulado',

  configUpdateNow: {
    consumption: {
      email: 'Volumen contratado email',
      sms: 'Volumen SMS contratado',
      semail: 'Saldo actual por correo electrónico',
      ssms: 'Saldo actual SMS',
    },

    template: {
      subject: 'Equipo de experiencia del cliente de devolución',
      sender: 'Ingrese el nombre del remitente',
      selectTemplate: 'Seleccione un template',
      pressTemplateName: 'Introduce el nombre de un template',
      sucess: 'Éxito',
      descriptionSucess: 'Grupo de tratativas criado com éxito',
      descriptionRemove: 'Grupo de tratativas eliminado com éxito',
      descriptionUpdate: 'Grupo de tratativas atualizado com éxito',
      alertAttetion: 'Atencion',
      alertDescription: '¡Complete todos los campos!',
      alertUpdate: 'Template actualizado',
      alertUpdateDescription: '¡Tu template ha sido cambiada con éxito!',
    },
    tratativeRules: {
      modalTitle: 'Agregar regla de tratativa',
      modalTitleEdit: 'Editar regla de tratativa',
      ruleTitle: 'Título de la regla',
      ruleTime: 'Reglas del período',
      classification: 'Ordenar por',
      newlast: 'Más reciente',
      oldest: ' Más antiguo',
      ruleStack: 'Reglas de la cola del operador',
      orderWork: 'Orden de trabajo ',
      schedule: 'Programado',
      detractor: 'Detractores',
      neutrals: 'Neutral',
      promoters: 'Promotores',
      chooseAnActions: 'Elegir acciones',
      actions: 'Acciones',
      selectAction: 'Seleccionar acciones',
      newRoleButton: 'Nueva regla de operación',
      isOn: 'Activo',
      ruleName: 'Nombre de la regla',
      editeRule: 'Editar',
      channel: 'Canal',
      save: 'Guardar',
      saveChange: 'Guardar ediciones',
    },
  },
  userPermissionTranslateUpdate: {
    actionPermissionTitle: 'Menu de Acciones',
    actionMenu: {
      viewMenu: 'Mirar Menu',
      details: 'Detalles',
      editAction: 'Editar Acción',
      sendDispatcher: 'Enviar (disparo)',
      deleteAction: 'Borrar Acciones',
      createAction: 'Crear Acciones',
    },
    menuAnswers: {
      answerMenuTitle: '',
      answerMenu: {
        viewMenu: '',
        editComment: '',
        deleteResponse: '',
        incognitoMode: '',
        categorizationMode: '',
      },
    },
    manualMenuTitle: '',
    manualMenu: {
      viewMenu: '',
      registerAnswer: '',
      icognitoMode: '',
    },
    menuDispatcherTitle: '',
    menuDispatcher: {
      viewMenu: '',
      viewRessend: '',
      viewWhatsApp: '',
      resendExecute: '',
      remindersView: '',
      cancelReminders: '',
      scheduleView: '',
      scheduleCancel: '',
      incognitoMode: '',
    },
    treatmentMenuTitle: '',
    treatmentMenu: {
      viewMenu: '',
      details: '',
      answerCategory: '',
      changeStatus: '',
      chancheClosedStatus: '',
      massTreatment: '',
      replyByEmail: '',
      categorizeNegotiations: '',
      enableComment: '',
      enableResponsible: '',
      enableAttachment: '',
    },
    reportMenuTitle: '',
    reportMenu: {
      viewMenu: '',
      powerBi: '',
      AIAnalysis: '',
    },
    menuTrashTitle: '',
    menuTrash: {
      viewMenu: '',
      restoreAnswer: '',
      restoreActions: '',
      incognitoMode: '',
    },
    menuDashboardTitle: '',
    menuDashboard: {
      viewMenu: '',
    },

    menuClientTitle: '',
    menuClient: {
      viewMenu: '',
      incognitoMode: '',
      editData: '',
    },
    menuActionGroupTitle: '',
    menuActionGroup: {
      viewMenu: '',
      actionAssociation: '',
    },
    ourFileTitle: '',
    ourFileTitle: {
      downloads: '',
      uploads: '',
    },
    panelsMenuTitle: '',
    panelsMenu: {
      viewMenu: '',
      sharePanel: '',
      createPanel: '',
      editPanel: '',
      deletePanel: '',
    },
    myConfigurationsTitle: '',
    myConfigurations: {
      viewMenu: '',
    },
  },

  acessProfileTranslateUpdate: {
    modaltitle: 'Opciones de reporte',
    describe: 'Habilite los reportes específicos de su cuenta para este perfil',
    especificReport: {
      searchMonitoring: 'Búsqueda de seguimiento',
      conversionReport: 'Informe de conversión/Detalle de importación',
      categories: 'Categoría x Tratamiento Etiqueta',
      htsReport: 'Reporte HTS',
    },
    especificReportTitle: 'Reportes específicos',
    apply: 'Habilitar',
  },

  tagsTreatmenTranslateUpdate: {
    title: 'Tag de tratamiento',
    addTag: 'Incluir Tag',
    removeTagTitle: 'Remover tag',
    describe: '¿Está seguro de que desea eliminar esta tag?',
  },
  actionUploadModal: {
    title: 'procesando',
    description:
      'Su archivo se está procesando, ¡espere! Esto puede tardar unos pocos segundos.',
  },
};

export default messages;



// WEBPACK FOOTER //
// ./src/lang/es.js